


















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import VueElementLoading from "vue-element-loading"
import { cloneDeep, debounce } from "lodash"
import VueDraggable from 'vuedraggable'
import Datepicker from "vue2-datepicker"
import moment from 'moment'
import axios from 'axios'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getLastDateOfQuarter, getLastDateOfMonth } from '@/modules/budget/monitoring/reports-constructor/common/utils/dateUtils'
import { Classificator } from "../../common/types/Classificator"
import { Transfert } from "../../common/types/Transfert"
import { TemplateCreateUpdateRequest } from "../../common/types/TemplateCreateUpdateRequest"
import { Template, TemplateForm } from "../../common/types/Template"
import { Option } from "../../common/types/Option"
import { FilterSettingsForm } from "../../common/types/roots/FilterSettingsForm"
import { FilterOptions } from "../../common/types/roots/FilterOptions"
import { Indicator } from "../../common/types/Indicator"
import {
    BudgetStructure,
    BudgetType,
    ByForm,
    CertificateLevel,
    CertificateType,
    ClassificationType,
    DataSource,
    ExpenseType,
    MutuallyRedeeming,
    PaymentType,
    Segmentation,
    StatusType
} from "../../common/types/roots/fields"
import { allBudgetTypesOptions, allClassificationTypesOptions, allIncomeClassificators, allReportNamesOptions, allPlanOptions, additionalSendersOptios } from "../../common/baseOptions"
import { kbkBehaviorConfig } from '../../common/kbkBehaviorConfig'
import { FilterSettings } from "../../common/types/roots/FilterSettings"
import { makeToast, validateClassificatorsBlock } from "../../common/utils/otherUtils"
import { TableData } from "../../common/types/roots/TableData"
import { LoadToJournalRequest } from "../../common/types/roots/LoadToJournalRequest"
import { reportCashExecExpenseIndicators, reportCashExecIncomeIndicators } from "../../reports/report-cash-exec/report-cash-exec"
import { reportReconStatementExpenseIndicators, reportReconStatementIncomeIndicators } from "../../reports/report-recon-statement/report-recon-statement"

import { Facade } from "../../common/Facade"
import { Report127Facade } from "../../reports/report-1-27/facade/Report127Facade"
import { Report127DailyFacade } from "../../reports/report-1-27-daily/facade/Report127DailyFacade"
import { Application2Facade } from "../../reports/application-2/facade/Application2Facade"
import { Report420Facade } from "../../reports/4-20/facade/Report420Facade"
import { ReportIRBOFacade } from "../../reports/report-irbo/facade/ReportIRBOFacade"
import { ReportDviFacade } from "../../reports/dvi/facade/ReportDviFacade"
import { ReportIPIPMFacade } from "../../reports/ipipm/facade/ReportIPIPMFacade"
import { Report127ActFacade } from "../../reports/report-1-27-act/facade/Report127ActFacade"
import { ReportDkiRFacade } from "../../reports/dki-r/facade/ReportDkiRFacade"
import { ReportDkiPFacade } from "../../reports/dki-p/facade/ReportDkiPFacade"
import { ReportEibFacade } from "../../reports/eib/facade/ReportEibFacade"
import { ReportIncomeFacade } from "../../reports/report-income/facade/ReportIncomeFacade"
import { getActiveIncomeSegments, getIncomeApplicability } from "../../reports/report-income/report-income"
import { ReportPlanCashFacade } from "../../reports/report-plan-cash/facade/ReportPlanCashFacade"
import { ReportCashExecFacade } from "../../reports/report-cash-exec/facade/ReportCashExecFacade"
import { ReportRsFacade } from "../../reports/rs/facade/ReportRsFacade"
import { SvodPlanFacade } from "../../reports/svod-plan/facade/SvodPlanFacade"
import { SvodDohFacade } from "../../reports/svod-doh/facade/SvodDohFacade"
import { ReportRtFacade } from "../../reports/rt/facade/ReportRtFacade"
import { ReportReconStatementFacade } from "../../reports/report-recon-statement/facade/ReportReconStatementFacade";
import { ReportBrFacade } from "../../reports/br/facade/ReportBrFacade"
import { ReportMBSPFacade } from "../../reports/mbsp/facade/ReportMBSPFacade"
import { ReconPfKfFacade } from "../../reports/recon-pf-kf/facade/ReconPfKfFacade"
import { Report243Facade } from "../../reports/2-43/facade/Report243Facade"
import { ReportSvodRasFacade } from "../../reports/svod-ras/facade/ReportSvodRasFacade"

import Application2 from "@/modules/budget/monitoring/reports-constructor/reports/application-2/table-component/application-2.vue"
import Report127 from "@/modules/budget/monitoring/reports-constructor/reports/report-1-27/table-component/report-1-27.vue"
import Report127Daily from "@/modules/budget/monitoring/reports-constructor/reports/report-1-27-daily/table-component/report-1-27-daily.vue"
import Report420 from "@/modules/budget/monitoring/reports-constructor/reports/4-20/table-component/report-4-20.vue"
import ReportIRBO from "@/modules/budget/monitoring/reports-constructor/reports/report-irbo/table-component/report-irbo.vue"
import ReportDvi from "@/modules/budget/monitoring/reports-constructor/reports/dvi/table-component/report-dvi.vue"
import ReportIPIPM from "@/modules/budget/monitoring/reports-constructor/reports/ipipm/table-component/report-ipipm.vue"
import ReportRDki from "../../reports/dki-r/table-component/report-dki-r.vue"
import Report127Act from "../../reports/report-1-27-act/table-component/report-1-27-act.vue"
import ReportDkiP from "../../reports/dki-p/table-component/report-dki-p.vue"
import ReportEib from "../../reports/eib/table-component/report-eib.vue"
import ReportIncome from "@/modules/budget/monitoring/reports-constructor/reports/report-income/table-component/report-income.vue"
import ReportPlanCash from "@/modules/budget/monitoring/reports-constructor/reports/report-plan-cash/table-component/report-plan-cash.vue"
import ReportCashExec from "@/modules/budget/monitoring/reports-constructor/reports/report-cash-exec/table-component/report-cash-exec.vue"
import ReportRs from "../../reports/rs/table-component/report-rs.vue"
import ReportRt from "../../reports/rt/table-component/report-rt.vue"
import { Report127BatchExportRequest } from "../../reports/report-1-27/journal/Report127BatchExportRequest"
import ReportSvodPlan from "../../reports/svod-plan/table-component/report-svod-plan.vue"
import ReportSvodDoh from "../../reports/svod-doh/table-component/report-svod-doh.vue"
import ReportReconStatement from "@/modules/budget/monitoring/reports-constructor/reports/report-recon-statement/table-component/report-recon-statement.vue";
import ReportBr from "../../reports/br/table-component/report-br.vue"
import ReportMBSP from "../../reports/mbsp/table-component/report-mbsp.vue"
import ReportReconPfKf from "../../reports/recon-pf-kf/table-component/report-recon-pf-kf.vue"
import Report243 from "../../reports/2-43/table-component/report-243.vue"
import ReportSvodRas from "../../reports/svod-ras/table-component/report-svod-ras.vue"
import i18nService from "@/services/i18n";

import DragableMultiselect from "@/components/custom/DragableMultiselect.vue";
import popUp from "../constructor/components/popUp.vue";
import CKbkSelector from "../../common/components/c-kbk-selector.vue";
import { KbkItem, KbkNameEntry } from "../../common/components/c-kbk-selector-types";
import { BatchExportRequest } from "../../common/types/roots/BatchExportRequest"
import { ReportRsBatchExportRequest } from "../../reports/rs/journal/ReportRsBatchExportRequest"
import { CertificateTypeRequest } from "../../reports/rs/data-request/ReportRsTableDataRequest"
import { ReportSvodPlanTableDataRequest } from "../../reports/svod-plan/ReportSvodPlanTableDataRequest"
import { ReportSvodDohTableDataRequest } from "../../reports/svod-doh/ReportSvodDohTableDataRequest"
import { LoanStatusFacade } from "../../reports/loan-status/facade/LoanStatusFacade"
import { KsnFacade } from "../../reports/ksn/facade/KsnFacade"
import ReportKsn from "../../reports/ksn/table-component/report-ksn.vue"
import ReportLoanStatus from "../../reports/loan-status/table-component/report-loan-status.vue"
import { ReportOwnIncomeFacade } from "../../reports/report-own-income/facade/ReportOwnIncomeFacade"
import ReportOwnIncome from "../../reports/report-own-income/table-component/report-own-income.vue"
import { SvodMbFacade } from "../../reports/svod-mb/facade/SvodMbFacade"
import ReportSvodMb from "../../reports/svod-mb/table-component/report-svod-mb.vue"
import { Kf219CoFacade } from "../../reports/kf219-co/facade/Kf219CoFacade"
import { isKf219CoMsuAggregationAvailable } from "../../reports/kf219-co/report-kf219-co"
import ReportKf219Co from "../../reports/kf219-co/table-component/report-kf219-co.vue"
// Интерфейсы для КБК с наименованиями
interface KbkOptionsResponse {
    paths: {
        income: (number | null)[][]
        func: (number | null)[][]
        econ: (number | null)[][]
    }
    level_order: {
        income: string[]
        func: string[]
        econ: string[]
    }
    label_key_positions: {
        income: Record<string, number[]>
        func: Record<string, number[]>
        econ: Record<string, number[]>
    }
    independent: {
        spf_func: number[][]
        pcl_econ: number[][]
        spf_econ: number[][]
    }
    names_ru: string[]
    names_kk: string[]
    labels: {
        income: Record<string, Record<string, number>>
        func: Record<string, Record<string, number>>
        econ: Record<string, Record<string, number>>
        spf_func: Record<string, number>
        pcl_econ: Record<string, number>
        spf_econ: Record<string, number>
    }
}

const personalCategoryOption = {
    label: 'Личные шаблоны',
    labelKk: 'Жеке үлгілер',
    labelEn: 'Personal templates',
    value: null
}
const initialTemplateForm: TemplateForm = {
    id: null,
    name: '',
    excelName: '',
    description: null,
    category: { ...personalCategoryOption },
    regions: null
}
const emptyTransfertOptions: Record<string, Option<string>[]> = {
    funding: [],
    gu: [],
    transfer_group: [],
    direction: [],
    project: [],
}
const batchExportEligibleTemplateNames = [
    'full',
    'aggregated',
    'economic',
    'current_programs',
    'development_programs',
    'budget_execution_incomes',
    'budget_execution_expenses',
    'budget_execution_by_abp'
].map(it => it.toLowerCase())

const nonEditableTemplateNames = [
    'full',
    'aggregated',
    'economic',
    'current_programs',
    'development_programs',
    'budget_execution_incomes',
    'budget_execution_expenses',
    'budget_execution_by_abp'
].map(it => it.toLowerCase())

@Component({
    components: {
        'loading': VueElementLoading,
        'draggable': VueDraggable,
        'date-picker': Datepicker,
        'application-2': Application2,
        'report-1-27': Report127,
        'report-1-27-daily': Report127Daily,
        'report-4-20': Report420,
        'report-irbo': ReportIRBO,
        'report-dvi': ReportDvi,
        'report-ipipm': ReportIPIPM,
        'report-loan-status': ReportLoanStatus,
        'report-ksn': ReportKsn,
        'report-svod-mb': ReportSvodMb,
        'report-kf219-co': ReportKf219Co,
        'report-dki-r': ReportRDki,
        'report-dki-p': ReportDkiP,
        'report-1-27-act': Report127Act,
        'report-eib': ReportEib,
        'report-income': ReportIncome,
        'report-plan-cash': ReportPlanCash,
        'report-cash-exec': ReportCashExec,
        'report-rs': ReportRs,
        'report-svod-plan': ReportSvodPlan,
        'report-svod-doh': ReportSvodDoh,
        'report-rt': ReportRt,
        'report-recon-statement': ReportReconStatement,
        'dragable-multiselect': DragableMultiselect,
        'pop-up': popUp,
        'report-br': ReportBr,
        'report-mbsp': ReportMBSP,
        'report-recon-pf-kf': ReportReconPfKf,
        'report-2-43': Report243,
        'report-svod-ras': ReportSvodRas,
        'report-own-income': ReportOwnIncome,
        'c-kbk-selector': CKbkSelector
    }
})

export default class FiltersForm extends Vue {
    // #region Props
    @Prop({
        type: Object,
        required: true
    })
    public readonly template!: Template

    @Prop({
        type: Function,
        required: true
    })
    public onSelectReport!: any

    @Prop({
        type: Boolean,
        required: true
    })
    public isIncomesAvailable!: boolean

    @Prop({
        type: Boolean,
        required: true
    })
    public isExpensesAvailable!: boolean

    @Prop({
        type: Object,
        required: true
    })
    public userAccessLevels!: Record<string, boolean>




    // #endregion

    // #region Data
    public tempI18Service: any = null
    public templateName = this.template.name
    private readonly moduleCode = '005.003.007'
    // Если тест/релиз то "00"
    private oblastKato: string = ''
    private facade: Facade | null = null
    public loading = false
    public regionLoading = false
    public isFilterPanelExpanded = true
    public saveModal = false
    public tableData: TableData | null = null
    // Дата, с которой реально сформирован tableData (снимок formToConstructReport.date на момент
    // клика "Сформировать") - НЕ то же самое, что filterSettingsForm.date, которая меняется сразу
    // при правке даты в фильтре, ДО повторного формирования. Нужна отдельно для report-svod-ras:
    // его заголовки колонок ("Факт на $date"/"$date_y1"/"$date_y2") вычисляются из даты через
    // проп date - если проп берётся из живой filterSettingsForm.date, заголовки "убегают" вперёд
    // данных таблицы при смене даты в фильтре без повторного нажатия "Сформировать".
    public tableGeneratedDate: Date | null = null
    /**
     * Предупреждение об отсутствии среза кассового исполнения на отчётную дату
     * (RQ.58/RQ.59, §5.4) — заполняется только для отчёта DKI-R (см. ReportDkiRFacade),
     * для остальных отчётов остаётся null.
     */
    public cashDateWarning: { requested: string; available: string | null } | null = null
    public tableSegmentations: Array<{ value: string; active: boolean }> = []
    public tableExpenses: Array<{ key: string; active: boolean }> = []
    public progress = 100
    private datePeriod: string | null = null
    private svodPlanStatusList: Option<StatusType>[] = []

    public templateForm: TemplateForm = cloneDeep(initialTemplateForm)
    public templateFormOptions = {
        reportCategoryOptions: [] as Option<string | null>[],
        regionOptions: [] as Option<string>[]
    }

    public filterSettingsForm: FilterSettingsForm | null = null
    public filterOptions: FilterOptions | null = null

    private brSupplierOptions: { value: string; label: string }[] = []

    public isAllSelectedTemplateRegion: boolean = false
    private isUserLead = false;
    private userGu: Option<string>[] = [];
    private userGu261: Option<string>[] = [];
    private rsGuList: Option<string>[] = [];
    private rsGuLoading = false;
    private rsGuStatusOptions: Option<StatusType>[] = [];

    // Дублирующие переменные incomes/outcomes
    // нужны для того чтобы при драггинге (dragging)
    // компоненты отрисовки таблиц не ререндерился с новым порядком
    // и сохранял тот порядок который был при нажатий "Сформировать"
    public incomesToPass: Classificator[] = []
    public expensesToPass: Classificator[] = []
    public transfertsToPass: Transfert[] = []

    public ksnRoundUp: boolean = false
    public ksnRoundUpTo: number | null = null

    public transfertOptions: Record<string, Option<string>[]> = cloneDeep(emptyTransfertOptions)

    // КБК с наименованиями — для широкой панели выбора
    public kbkOptions: KbkOptionsResponse | null = null

    // Счётчик для защиты от гонки при загрузке kbk-options
    private kbkLoadSeq = 0

    // Чтобы сохранить параметры в момент нажатия 'сформировать',
    // нужно потому что показатели (indicators) задаются после формирования
    private journalParams: LoadToJournalRequest | null = null

    // Нужно чтобы затригерить re-render компонентов отрисовок таблиц
    public tableKey = 0

    private oblastCode: string = ''
    private lastSvodStatuses: string[] = []
    private lastSvodDohStatuses: string[] = []


    // #endregion

    // #region Computed
    // 2-43: «Уровни ВЗК» доступны только при «только ВЗК» / «без ВЗК»
    get isMutuallyRedeemingLevelsDisabled(): boolean {
        return this.filterSettingsForm?.key === '2-43'
            && this.filterSettingsForm.mutuallyRedeeming?.value === 'WITH'
    }

    get isNewForm(): boolean {
        return this.templateForm.id == null
    }

    get userId(): string {
        return this.$store.state.user.sub;
    }

    get kbkQueryKey(): string {
        const fq = this.filterSettingsForm as any
        const date = this.getKbkDate()
        const bt: number[] = Array.isArray(fq?.budgetTypes)
            ? fq.budgetTypes.map((b: any) => b?.value).filter((v: any) => v != null)
            : (fq?.budgetType?.value != null ? [fq.budgetType.value] : [])
        const dtVal = fq?.developType?.value
        return `${date}|${bt.join(',')}|${dtVal != null ? String(dtVal) : ''}`
    }

    get username(): string {
        return this.$store.state.user.preferred_username
    }

    get hasEditAccess(): boolean {
        const accessLevel = this.$store.state.user.userModules.find((it: any) => it.modules === this.moduleCode)?.access_level
        return accessLevel >= 2
    }

    get isAdmin(): boolean {
        const accessLevel = this.$store.state.user.userModules.find((it: any) => it.modules === this.moduleCode)?.access_level
        return accessLevel == 3
    }

    get isBatchExportTemplate(): boolean {
        return this.template.filterSettings.reportName === '1-27'
            && batchExportEligibleTemplateNames.includes(this.template.name.toLowerCase())
            && this.template.category === '70'
    }

    get isSupplierFilterEnabled(): boolean {
        if (this.filterSettingsForm?.key !== 'BR') return false
        const f = this.filterSettingsForm as any
        return !!(f.date && f.region && f.budgetTypes?.length > 0 && f.developType != null)
    }

    get supplierOptionsForSelect(): { value: string; label: string }[] {
        const selected = (this.filterSettingsForm as any)?.suppliers ?? []
        const selectedValues = new Set(selected.map((s: any) => s.value))
        const rest = this.brSupplierOptions.filter(o => !selectedValues.has(o.value))
        return [...selected, ...rest]
    }

    get isStructuredBudgetPossible(): boolean {
        if (this.filterSettingsForm == null
        || !('incomes' in this.filterSettingsForm)
        || !('expenses' in this.filterSettingsForm)) {
            return false
        }
        let isPossible: boolean = true

        // 1. Проверка по выбранности (должны быть оба)
        const hasChosenIncome = this.filterSettingsForm.incomes.filter(it => it.active).length > 0
        const hasChosenExpense = this.filterSettingsForm.expenses.filter(it => it.active).length > 0
        if (!hasChosenIncome || !hasChosenExpense) {
            isPossible = false
        }

        // Side-effect костыль (чтобы не создавать watch)
        if (!isPossible) {
            if (this.filterSettingsForm?.key === '1-27' && this.filterOptions?.key === '1-27') {
                this.filterSettingsForm.budgetStructure = this.filterOptions.budgetStructures.find(it => it.value === 'WITHOUT') ?? null
            }
        }

        return isPossible
    }

    get budgetStructureOptions(): Option<BudgetStructure>[] {
        if (this.filterSettingsForm?.key === '1-27' && this.filterOptions?.key === '1-27') {
            const options = this.isStructuredBudgetPossible ? this.filterOptions.budgetStructures : this.filterOptions.budgetStructures.filter(it => it.value === 'WITHOUT')
            return options
        }

        if (this.filterOptions && 'budgetStructures' in this.filterOptions) {
            return this.filterOptions.budgetStructures
        }
        return []
    }

    get classificationTypeOptions(): Option<ClassificationType>[] {
        if (!this.filterOptions) {
            return []
        }
        if (this.filterOptions.key === 'RS' && this.filterSettingsForm?.key === 'RS') {
            if (this.filterSettingsForm.certificateLevel?.value === 'ABP' || this.filterSettingsForm.certificateLevel?.value === 'GU') {
                const expenseOptions = this.filterOptions.classificationTypes.filter(it => it.value === 'EXPENSES')

                // Side-effect чтобы присвоить значение "Классификация"
                if (this.filterSettingsForm.classificationType.value !== 'EXPENSES') {
                    this.filterSettingsForm.classificationType = cloneDeep(expenseOptions[0])
                }

                return expenseOptions
            }
        }
        return this.filterOptions.classificationTypes
    }

    get byFormFilterOptions(): Option<ByForm>[] {
        if (this.filterSettingsForm?.key === 'CASH-EXEC' && this.filterOptions?.key === 'CASH-EXEC') {
            let byFormOptions: Option<ByForm>[] = []
            if (this.filterSettingsForm.classificationType.value === 'INCOMES') {
                byFormOptions = this.filterOptions.byForms.filter(it => it.value === '2-19')
            } else if (this.filterSettingsForm.classificationType.value === 'EXPENSES') {
                const av_forms: ByForm[] = ['4-20']
                if (this.filterSettingsForm.dataSource2.value !== 'IISK') {
                    av_forms.push('5-42')
                }
                byFormOptions = this.filterOptions.byForms.filter(it => av_forms.includes(it.value))
            }

            return byFormOptions
        }

        if (this.filterSettingsForm?.key === 'SVOD-RAS' && this.filterOptions?.key === 'SVOD-RAS') {
            return this.filterOptions.byForms
        }

        if (this.filterOptions && 'byForms' in this.filterOptions) {
            return this.filterOptions.byForms
        }
        return []
    }

    get statusOptions(): Option<StatusType>[] {
        if (!this.filterOptions || !('statuses' in this.filterOptions)) {
            return []
        }

        if (this.filterOptions.key === 'RS' && this.filterSettingsForm?.key === 'RS') {
            if (this.filterSettingsForm.certificateLevel?.value === 'UO') {
                return this.filterOptions.statuses.filter(it =>
                    ['39', '26', '27', '1', '37', '38'].includes(it.value)
                )
            } else if (this.filterSettingsForm.certificateLevel?.value === 'ABP') {
                return this.filterOptions.statuses.filter(it =>
                    ['39', '26', '27', '1', '37', '38', '32', '31', '28'].includes(it.value)
                )
            } else if (this.filterSettingsForm.certificateLevel?.value === 'GU') {
                return this.rsGuStatusOptions
            }
            return []
        } else if (this.filterOptions.key === 'SVOD-PLAN' && this.filterSettingsForm?.key === 'SVOD-PLAN') {
            if (!this.svodPlanStatusList.length) {
                this.getStatusList()
            }
            return this.svodPlanStatusList
        }

        return this.filterOptions.statuses
    }

    get certificateTypeOptions(): Option<CertificateType>[] {
        if (!this.filterOptions || !('certificateTypes' in this.filterOptions)) {
            return []
        }

        if (this.filterSettingsForm?.key === 'RS' && this.filterOptions?.key === 'RS') {
            const ct = this.filterSettingsForm.classificationType.value
            if (ct === 'INCOMES' || ct === 'MIXED') {
                // INTERNAL (Внутренняя) нет у доходов
                return this.filterOptions.certificateTypes.filter(it => it.value !== 'INTERNAL')
            }
            return this.filterOptions.certificateTypes
        }

        return this.filterOptions.certificateTypes
    }

    get isSeparateByRegionCheckboxDisabled(): boolean {
        if (this.filterSettingsForm?.key === '1-27') {
            const form = this.filterSettingsForm

            const anyActiveIncomeClassificator = form.incomes.filter(it => it.active).length > 0
            const anyActiveExpenseClassificator = form.expenses.filter(it => it.active).length > 0

            const anyActiveClassification = anyActiveIncomeClassificator || anyActiveExpenseClassificator
            const anyActiveTotal = form.incomeTotal || form.expenseTotal

            if (anyActiveClassification && anyActiveTotal) {
                // Side-effect to uncheck 'В разрезе бюджета'
                this.filterSettingsForm.separateByRegion = false
                return true
            }
        }

        return false
    }

    get isDecodingActualRegionalBudgetCheckboxDisabled(): boolean {
        if (this.filterSettingsForm?.key === 'IRBO') {
            const lastFour = this.filterSettingsForm.region?.value.slice(2);
            const lastTwo = this.filterSettingsForm.region?.value.slice(4);
            return (
                lastFour !== "0000"  &&
                (
                    lastFour === "0101" ||
                    lastTwo === "00"
                )
            )
        }
        if (this.filterSettingsForm?.key === 'INCOME') {
            return !this.getIncomeApplicabilityState().decodingActualRegionalBudget
        }

        return false
    }

    /** INCOME: какие переключатели применимы при текущей разрезности и isTree (см. getIncomeApplicability) */
    private getIncomeApplicabilityState() {
        if (this.filterSettingsForm?.key !== 'INCOME' || !('segmentations' in this.filterSettingsForm)) {
            return getIncomeApplicability([], false)
        }
        return getIncomeApplicability(
            getActiveIncomeSegments(this.filterSettingsForm.segmentations),
            !!this.filterSettingsForm.isTree
        )
    }

    public get showMsuAggregation(): boolean {
        if (!this.filterSettingsForm || !('msuAggregation' in this.filterSettingsForm)) return false
        const fs = this.filterSettingsForm as any

        // Определяем код региона: одиночный (CASH-EXEC) или из списка (1-27, 1-27-DAILY)
        let regionCode: string
        if ('region' in fs && fs.region) {
            regionCode = fs.region?.value ?? ''
        } else if ('regions' in fs && Array.isArray(fs.regions)) {
            const regions = fs.regions as any[]
            if (regions.length !== 1) return false
            regionCode = regions[0]?.value ?? ''
        } else {
            return false
        }

        if (regionCode.length !== 6 || ['59', '60', '62'].includes(regionCode.slice(0, 2))) return false
        const isWholeObl = regionCode.endsWith('0000')
        const isDistrictNode = regionCode.endsWith('00') && !['00', '01'].includes(regionCode.slice(2, 4))
        if (!isWholeObl && !isDistrictNode) return false

        // KF219-CO: поля "Бюджет" в отчёте нет — условие только по региону и разрезности "Регион"
        if (fs.key === 'KF219-CO') {
            return isKf219CoMsuAggregationAvailable(regionCode, fs.segmentations)
        }

        const budgetTypes: number[] = fs.budgetTypes?.map((b: any) => Number(b.value)) ?? []
        if (!budgetTypes.includes(3) || !budgetTypes.includes(6)) return false

        // Условие разрезности зависит от типа отчёта
        const reportKey: string = fs.key ?? ''
        if (reportKey === '1-27') {
            return fs.separateByRegion === true
        }
        // Для CASH-EXEC и 1-27-DAILY: REGION должен быть активен в разрезности
        const hasRegionSegmentation = fs.segmentations?.some((s: any) => s.value === 'REGION' && s.active) ?? false
        return hasRegionSegmentation
    }

    @Watch('showMsuAggregation')
    public onShowMsuAggregationChange(isShown: boolean) {
        // условие перестало выполняться — настройку сразу выключаем, не дожидаясь «Сформировать»
        if (!isShown && this.filterSettingsForm && 'msuAggregation' in this.filterSettingsForm) {
            this.filterSettingsForm.msuAggregation = false
        }
    }

    get showSortByRegionCode(): boolean {
        if (!this.filterSettingsForm || !('sortByRegionCode' in this.filterSettingsForm)) return false
        const fs = this.filterSettingsForm as any
        const key = fs.key

        if (key === 'IRBO') {
            return !!fs.region?.value?.endsWith('00')
        }
        if (key === 'CASH-EXEC') {
            const hasRegionSegmentation = fs.segmentations?.some((s: any) => s.value === 'REGION' && s.active) ?? false
            return !!fs.region?.value?.endsWith('00') && hasRegionSegmentation
        }
        if (key === 'KSN') {
            return !!fs.region?.value?.endsWith('00')
        }
        if (key === 'SVOD-MB') {
            return !!fs.region?.value?.endsWith('00')
        }
        if (key === 'income_kbk') {
            const regions: any[] = fs.regions ?? []
            return regions.length > 1 || regions.some((r: any) => r.value?.endsWith('0000'))
        }
        if (key === 'INCOME') {
            const regions: any[] = fs.regions ?? []
            const hasRegionSegmentation = fs.segmentations?.some((s: any) => s.value === 'REGION' && s.active) ?? false
            return hasRegionSegmentation && (regions.length > 1 || regions.some((r: any) => r.value?.endsWith('0000')))
        }
        if (key === 'EIB') {
            const hasRegionSegmentation = fs.segmentations?.some((s: any) => s.value === 'REGION' && s.active) ?? false
            return !!fs.region?.value?.endsWith('00') && hasRegionSegmentation
        }
        return false
    }

    get isRegionsTotalCheckboxDisabled(): boolean {
        if (this.filterSettingsForm?.key === 'INCOME') {
            return !this.getIncomeApplicabilityState().regionsTotal
        }
        if (this.filterSettingsForm?.key === 'SVOD-RAS') {
            const hasRegionSegmentation = this.filterSettingsForm.segmentations?.some(s => s.value === 'REGION' && s.active) ?? false
            return !(!!this.filterSettingsForm.region?.value?.endsWith('00') && hasRegionSegmentation)
        }
        return false
    }

    get isPrevYearCheckboxDisabled(): boolean {
        if (this.filterSettingsForm?.key === 'INCOME') {
            return !this.getIncomeApplicabilityState().prevYear
        }
        return false
    }

    get isIsTreeDisabled(): boolean {
        if (this.filterSettingsForm?.key === 'INCOME') {
            return !this.getIncomeApplicabilityState().isTree
        }
        return false
    }

    /** «Наименование перед КБК»: показывается в отчётах, у которых есть эта настройка */
    get showNameBeforeKbk(): boolean {
        return !!this.filterSettingsForm && 'nameBeforeKbk' in this.filterSettingsForm
    }

    /**
     * «Наименование перед КБК»:
     * INCOME — доступно только для «КБК + дерево» и «Регион → КБК»;
     * CASH-EXEC — только при древовидной структуре (в плоском режиме колонок КБК нет)
     */
    get isNameBeforeKbkDisabled(): boolean {
        if (this.filterSettingsForm?.key === 'INCOME') {
            return !this.getIncomeApplicabilityState().nameBeforeKbk
        }
        if (this.filterSettingsForm?.key === 'CASH-EXEC') {
            return !this.filterSettingsForm.isTree
        }
        return false
    }

    /**
     * INCOME: сбрасывает переключатели, ставшие недоступными (вызывается при действиях пользователя:
     * смена разрезности, isTree). Порядок важен: сначала isTree, от него зависит nameBeforeKbk.
     */
    private resetIncomeInapplicableFlags() {
        const form = this.filterSettingsForm
        if (form?.key !== 'INCOME' || !('segmentations' in form)) {
            return
        }
        const segs = getActiveIncomeSegments(form.segmentations)
        const ok = getIncomeApplicability(segs, !!form.isTree)
        if (!ok.isTree) form.isTree = false
        const okAfterTree = getIncomeApplicability(segs, !!form.isTree)
        if (!okAfterTree.prevYear) form.prevYear = false
        if (!okAfterTree.regionsTotal) form.regionsTotal = false
        if (!okAfterTree.decodingActualRegionalBudget) form.decodingActualRegionalBudget = false
        if (!okAfterTree.nameBeforeKbk) form.nameBeforeKbk = false
    }

    /** KF219-CO: без "КБК" в разрезности флажки уровней блока "Доходы" недоступны (отбор кодов при этом действует) */
    get isKf219CoKbkSegmentationOff(): boolean {
        if (this.filterSettingsForm?.key !== 'KF219-CO') {
            return false
        }
        return !this.filterSettingsForm.segmentations.some(it => it.value === 'KBK' && it.active)
    }

    get isFillCbcDisabled(): boolean {
        if (this.filterSettingsForm?.key === 'CASH-EXEC' || this.filterSettingsForm?.key === 'KF219-CO') {
            return !this.filterSettingsForm.isTree
        }

        return false
    }

    get isDataSourceDisabled(): boolean {
        if (this.filterSettingsForm?.key === 'CASH-EXEC' || this.filterSettingsForm?.key === 'INCOME' || this.filterSettingsForm?.key === 'RECON-STATEMENT' || this.filterSettingsForm?.key === '1-27-DAILY' || this.filterSettingsForm?.key === 'MBSP' || this.filterSettingsForm?.key === '2-43' || this.filterSettingsForm?.key === 'IRBO' || this.filterSettingsForm?.key === 'OWN-INCOME' || this.filterSettingsForm?.key === 'SVOD-RAS' || this.filterSettingsForm?.key === 'KF219-CO') {
            return false
        }
        return true
    }

    get isByFormDisabled(): boolean {
        // Для 1-27-DAILY: byForm активен только при источнике данных "Загрузчик"
        if (this.filterSettingsForm?.key === '1-27-DAILY') {
            return this.filterSettingsForm.dataSource?.value !== 'LOADER'
        }
        // SVOD-RAS: форма зафиксирована на 4-20, недоступна для изменения (§4 постановки)
        if (this.filterSettingsForm?.key === 'SVOD-RAS') {
            return true
        }
        // KF219-CO: форма зафиксирована на 2-19
        if (this.filterSettingsForm?.key === 'KF219-CO') {
            return true
        }
        return false
    }

    get isByFormsDisabled(): boolean {
        return ['MBSP', undefined].includes(this.filterSettingsForm?.key)
    }

    // Для 1-27-DAILY: ограничение КБК только когда "Регион" — единственная активная разрезность
    get dailyActiveSegmentations(): string[] {
        if (this.filterSettingsForm?.key !== '1-27-DAILY') return []
        if (!('segmentations' in this.filterSettingsForm)) return []
        return this.filterSettingsForm.segmentations.filter(s => s.active).map(s => s.value)
    }

    get isDailyRegionActive(): boolean {
        if (this.filterSettingsForm?.key !== '1-27-DAILY') return false
        if (!('segmentations' in this.filterSettingsForm)) return false
        const activeSegmentations = this.filterSettingsForm.segmentations.filter(s => s.active)
        // Отключаем КБК чекбоксы если КБК не выбран в разрезности
        return activeSegmentations.length > 0 && !activeSegmentations.some(s => s.value === 'KBK')
    }

    get isClassificationTypeDisabled(): boolean {
        if (['CASH-EXEC', 'RS', 'DVI', 'RECON-STATEMENT'].includes(this.filterSettingsForm?.key ?? '')) {
            return false
        }
        return true
    }

    get isPaymentTypeDisabled(): boolean {
        if (this.filterSettingsForm?.key === 'RS') {
            const ct = this.filterSettingsForm.classificationType.value
            return ct !== 'EXPENSES' // INCOMES и MIXED — не активно (MIXED фиксировано на Платежи)
        }
        else if (this.filterSettingsForm?.key === 'DVI') {
            return this.filterSettingsForm.classificationType.value !== 'EXPENSES'
        }
        return false
    }

    get isCertificateLevelDisabled(): boolean {
        if (this.filterSettingsForm?.key === 'RS') {
            const ct = this.filterSettingsForm.classificationType.value
            return ct === 'INCOMES' || ct === 'MIXED' // MIXED фиксировано на УО
        }
        return false
    }

    get isPlanTypeDisabled(): boolean {
        if (this.filterSettingsForm?.key === 'SVOD-PLAN') {
            return !this.isUserLead
        }
        return false
    }

    get isIncomeClassificationsHidden(): boolean {
        if (this.filterSettingsForm?.key === 'CASH-EXEC') {
            return this.filterSettingsForm.segmentations?.length === 1 && !this.filterSettingsForm.segmentations.filter(v => v.active).map(v => v.value).includes('KBK')
        }
        return false
    }

    get isExpenseClassificationsHidden(): boolean {
        if (this.filterSettingsForm?.key === 'CASH-EXEC') {
            return this.filterSettingsForm.segmentations?.length === 1 && !this.filterSettingsForm.segmentations.filter(v => v.active).map(v => v.value).includes('KBK')
        }
        return false
    }

    get isReportTypeHidden(): boolean {
        return ['CASH-EXEC', 'MBSP', 'RECON-PF-KF', '2-43', 'SVOD-RAS', undefined].includes(this.filterSettingsForm?.key)
    }

    get isPeriodicityHidden(): boolean {
        return this.filterSettingsForm?.key === 'CASH-EXEC' || this.filterSettingsForm?.key === 'SVOD-PLAN' || this.filterSettingsForm?.key === 'RECON-STATEMENT' || this.filterSettingsForm?.key === 'income_kbk' || this.filterSettingsForm?.key === 'MBSP' || this.filterSettingsForm?.key === 'RECON-PF-KF' || this.filterSettingsForm?.key === '2-43' || this.filterSettingsForm?.key === 'OWN-INCOME' || this.filterSettingsForm?.key === 'SVOD-RAS'
    }

    get classificationTypeHidden(): boolean {
        return this.filterSettingsForm?.key === 'SVOD-PLAN' || this.filterSettingsForm?.key === 'RECON-PF-KF'
    }

    get typePFHidden(): boolean {
        if (this.filterSettingsForm === null || this.filterOptions === null) return false
        if (!('typePF' in this.filterSettingsForm) || !('typePFs' in this.filterOptions)) return false
        if (this.filterSettingsForm.key === 'RECON-PF-KF') return true
        return 'planType' in this.filterSettingsForm && this.filterSettingsForm.planType.value === 'PF'
    }

    get guHidden(): boolean {
        return ((
            this.filterSettingsForm !== null &&
            this.filterOptions !== null &&
            'gu' in this.filterSettingsForm &&
            'gu' in this.filterOptions &&
            ('planType' in this.filterSettingsForm && this.filterSettingsForm.planType.value === 'PF')
        ) && (('typePF' in this.filterSettingsForm && this.filterSettingsForm.typePF.value === 'IPF') || this.guDepartment))
            || ((this.filterSettingsForm?.key === 'RECON-STATEMENT' && this.filterSettingsForm?.classificationType.value === 'EXPENSES') || this.guDepartment)
    }

    get isSegmentationHidden(): boolean {
        if (this.filterSettingsForm?.key === 'SVOD-PLAN') {
            return this.filterSettingsForm.typePF.value !== 'IPF' || this.filterSettingsForm.planType.value === 'PP'
        }
        return true
    }

    get statusHidden(): boolean {
        if (this.filterSettingsForm?.key === 'SVOD-PLAN') {
            return this.filterSettingsForm?.svodType?.value !== 'APPROVED';
        } else {
            return (
                this.filterSettingsForm != null &&
                this.filterOptions != null &&
                'statuses' in this.filterSettingsForm &&
                'statuses' in this.filterOptions
            );
        }
    }

    get monthHidden():boolean {
        if (this.filterSettingsForm?.key === 'RECON-STATEMENT' || this.filterSettingsForm?.key === 'RECON-PF-KF') {
            return !('periodicity' in this.filterSettingsForm) || this.filterSettingsForm?.periodicity.value !== 'DAY'
        } else {
            return !!((this.filterSettingsForm  && 'month' in this.filterSettingsForm) && (this.filterOptions && 'months' in this.filterOptions))
        }
    }

    get guDepartment(): boolean {
        if (this.filterSettingsForm?.key === 'SVOD-PLAN' && this.filterSettingsForm.typePF.value === 'PF') {
            const abpList = this.filterSettingsForm.expenses.find(
                item => item.key === 'abp' && item.active
            );

            if (abpList?.selected != null) {
                const selected = Array.isArray(abpList.selected)
                    ? abpList.selected
                    : [abpList.selected]; // если это не массив — обернём в массив
                return selected.includes(261);
            }
        }

        return false;
    }

    get guFilterTitle(): boolean {
        if (this.filterSettingsForm?.key === 'SVOD-PLAN' && this.filterSettingsForm.typePF.value === 'PF' && this.guDepartment) {
            return true;
        }
        return false;
    }

    // --- КБК с наименованиями: вспомогательные методы ---

    /**
     * Строит список KbkItem[] для заданного уровня на основе paths-формата ответа kbk-options.
     */
    public buildKbkItems(
        paths: (number | null)[][],
        levelKey: string,
        levelOrder: string[],
        labelKeyPositions: number[],
        labelsForLevel: Record<string, number>,
        namesRu: string[],
        namesKk: string[],
        cascadedPaths: (number | null)[][]
    ): KbkItem[] {
        const levelPos = levelOrder.indexOf(levelKey)
        const parentKeyPositions = labelKeyPositions.slice(0, -1)

        const grouped = new Map<number, { key: string; nameRu: string; nameKk: string; parents: {levelKey: string; code: number}[] }[]>()
        const seenKeys = new Map<number, Set<string>>()

        for (const path of cascadedPaths) {
            const code = path[levelPos]
            if (code == null) continue

            const keyParts = labelKeyPositions.map(i => path[i])
            if (keyParts.some(v => v == null)) continue
            const labelKey = keyParts.join(',')

            const nameIdx = labelsForLevel[labelKey]
            if (nameIdx == null) continue

            if (!grouped.has(code)) {
                grouped.set(code, [])
                seenKeys.set(code, new Set())
            }
            if (seenKeys.get(code)!.has(labelKey)) continue
            seenKeys.get(code)!.add(labelKey)

            const parents = parentKeyPositions
                .map(i => ({ levelKey: levelOrder[i], code: path[i] as number }))
                .filter(p => p.code != null)

            grouped.get(code)!.push({
                key: labelKey,
                nameRu: namesRu[nameIdx] ?? '',
                nameKk: namesKk[nameIdx] ?? '',
                parents
            })
        }

        const result: KbkItem[] = []
        for (const [code, entries] of grouped) {
            const nameEntries = (entries.length > 1 && entries.every(e => e.nameRu === entries[0].nameRu))
                ? [{ name_ru: entries[0].nameRu, name_kk: entries[0].nameKk, parents: [] }]
                : entries.map(e => ({ name_ru: e.nameRu, name_kk: e.nameKk, parents: e.parents }))
            result.push({ code, nameEntries })
        }
        return result.sort((a, b) => a.code - b.code)
    }

    /**
     * Возвращает коды уровня, совместимые с выборками других уровней (каскад по paths).
     */
    public getCascadeFilteredCodes(
        paths: (number | null)[][],
        levelPos: number,
        selectionsByPos: Map<number, Set<number>>
    ): Set<number> {
        const result = new Set<number>()
        for (const path of paths) {
            const code = path[levelPos]
            if (code == null) continue
            let ok = true
            for (const [pos, selected] of selectionsByPos) {
                const val = path[pos]
                if (val == null || !selected.has(val)) { ok = false; break }
            }
            if (ok) result.add(code)
        }
        return result
    }

    /**
     * Возвращает options и cascadeOptions для уровня доходов.
     */
    public getIncomeOptions(levelKey: string): { options: KbkItem[]; cascadeOptions: KbkItem[] } {
        if (!this.kbkOptions) return { options: [], cascadeOptions: [] }

        const { paths, level_order, label_key_positions, labels, names_ru, names_kk } = this.kbkOptions
        const levelOrder = level_order.income
        const levelPos = levelOrder.indexOf(levelKey)
        if (levelPos < 0) return { options: [], cascadeOptions: [] }

        const selectionsByPos = new Map<number, Set<number>>()
        if (this.filterSettingsForm && 'incomes' in this.filterSettingsForm) {
            for (const inc of (this.filterSettingsForm as any).incomes) {
                if (inc.key !== levelKey && inc.selected?.length > 0) {
                    const pos = levelOrder.indexOf(inc.key)
                    if (pos >= 0) selectionsByPos.set(pos, new Set(inc.selected))
                }
            }
        }

        // Пути, реально совместимые со всеми текущими выборками (Т1)
        const isCompatible = (p: (number | null)[]) => {
            for (const [pos, selected] of selectionsByPos) {
                const v = p[pos]
                if (v == null || !selected.has(v)) return false
            }
            return true
        }
        const cascadePaths = paths.income.filter(p => p[levelPos] != null && isCompatible(p))
        const cascadeCodes = new Set<number>(cascadePaths.map(p => p[levelPos] as number))

        // Т3: выбранные ранее несовместимые коды остаются видимыми (все их пути)
        const selectedCodes = new Set<number>(
            (this.filterSettingsForm && 'incomes' in this.filterSettingsForm)
                ? ((this.filterSettingsForm as any).incomes.find((i: any) => i.key === levelKey)?.selected || [])
                : []
        )
        const extraPaths = paths.income.filter(p => {
            const c = p[levelPos]
            return c != null && selectedCodes.has(c) && !cascadeCodes.has(c)
        })
        const relevantPaths = [...cascadePaths, ...extraPaths]

        const lkp = label_key_positions.income[levelKey] ?? []
        const lbl = labels.income[levelKey] ?? {}

        const options = this.buildKbkItems(paths.income, levelKey, levelOrder, lkp, lbl, names_ru, names_kk, relevantPaths)
        const cascadeOptions = this.buildKbkItems(paths.income, levelKey, levelOrder, lkp, lbl, names_ru, names_kk, cascadePaths)
        return { options, cascadeOptions }
    }

    /**
     * Возвращает options и cascadeOptions для уровня расходов.
     * SPF (spf_func) и PCL/SPF экономической классификации — независимые, без каскада.
     */
    public getExpenseOptions(levelKey: string): { options: KbkItem[]; cascadeOptions: KbkItem[] } {
        if (!this.kbkOptions) return { options: [], cascadeOptions: [] }
        const { paths, level_order, label_key_positions, labels, names_ru, names_kk, independent } = this.kbkOptions

        const makeIndependent = (indPaths: number[][], lblMap: Record<string, number>): { options: KbkItem[]; cascadeOptions: KbkItem[] } => {
            const items: KbkItem[] = indPaths
                .map(p => p[0])
                .filter((c): c is number => c != null)
                .sort((a, b) => a - b)
                .map(code => {
                    const nameIdx = lblMap[String(code)]
                    const nameEntries = nameIdx != null
                        ? [{ name_ru: names_ru[nameIdx] ?? '', name_kk: names_kk[nameIdx] ?? '', parents: [] }]
                        : []
                    return { code, nameEntries }
                })
            return { options: items, cascadeOptions: items }
        }

        if (levelKey === 'spf' && labels.spf_func) {
            return makeIndependent(independent.spf_func, labels.spf_func)
        }
        if (levelKey === 'pcl' && labels.pcl_econ) {
            return makeIndependent(independent.pcl_econ, labels.pcl_econ)
        }

        // Функциональная классификация — каскад по func
        const levelOrder = level_order.func
        const levelPos = levelOrder.indexOf(levelKey)
        if (levelPos < 0) return { options: [], cascadeOptions: [] }

        const selectionsByPos = new Map<number, Set<number>>()
        if (this.filterSettingsForm && 'expenses' in this.filterSettingsForm) {
            for (const exp of (this.filterSettingsForm as any).expenses) {
                if (exp.key !== levelKey && exp.key !== 'spf' && exp.key !== 'pcl' && exp.selected?.length > 0) {
                    const pos = levelOrder.indexOf(exp.key)
                    if (pos >= 0) {
                        const sel = new Set<number>(exp.selected)
                        // Код 0 («Без подпрограммы») не участвует в каскадном сужении
                        if (exp.key === 'ppr') sel.delete(0)
                        if (sel.size > 0) selectionsByPos.set(pos, sel)
                    }
                }
            }
        }

        // Пути, реально совместимые со всеми текущими выборками (Т1)
        const isFuncCompatible = (p: (number | null)[]) => {
            for (const [pos, selected] of selectionsByPos) {
                const v = p[pos]
                if (v == null || !selected.has(v)) return false
            }
            return true
        }
        const cascadePaths = paths.func.filter(p => p[levelPos] != null && isFuncCompatible(p))
        const cascadeCodes = new Set<number>(cascadePaths.map(p => p[levelPos] as number))

        // Т3: выбранные ранее несовместимые коды остаются видимыми (все их пути)
        const selectedCodes = new Set<number>(
            (this.filterSettingsForm && 'expenses' in this.filterSettingsForm)
                ? ((this.filterSettingsForm as any).expenses.find((e: any) => e.key === levelKey)?.selected || [])
                : []
        )
        const extraPaths = paths.func.filter(p => {
            const c = p[levelPos]
            return c != null && selectedCodes.has(c) && !cascadeCodes.has(c)
        })
        const relevantPaths = [...cascadePaths, ...extraPaths]

        const lkp = label_key_positions.func[levelKey] ?? []
        const lbl = labels.func[levelKey] ?? {}

        const options = this.buildKbkItems(paths.func, levelKey, levelOrder, lkp, lbl, names_ru, names_kk, relevantPaths)
        const cascadeOptions = this.buildKbkItems(paths.func, levelKey, levelOrder, lkp, lbl, names_ru, names_kk, cascadePaths)

        if (levelKey === 'ppr' && (kbkBehaviorConfig[this.template.filterSettings.reportName]?.pprNoneOption ?? true)) {
            const noneItem: KbkItem = {
                code: 0,
                nameEntries: [{ name_ru: 'Без подпрограммы', name_kk: 'Кіші бағдарламасыз', parents: [] }]
            }
            options.unshift(noneItem)
            cascadeOptions.unshift(noneItem)
        }

        return { options, cascadeOptions }
    }

    get incomesHidden(): boolean {
        if (!this.isIncomesAvailable) {
            return false
        }

        if (this.filterSettingsForm?.key === 'SVOD-PLAN') {
            return this.filterSettingsForm.planType?.value === 'PP';
        } else {
            return (
                !!this.filterSettingsForm?.classificationType?.value &&  // Ensure this is a boolean (true/false)
                ['MIXED', 'INCOMES'].includes(this.filterSettingsForm.classificationType.value) &&
                this.filterSettingsForm != null && 'incomes' in this.filterSettingsForm
            );
        }
    }

    get cachedIncomeOptions(): Record<string, { options: KbkItem[]; cascadeOptions: KbkItem[] }> {
        if (!this.kbkOptions || !this.filterSettingsForm || !('incomes' in this.filterSettingsForm)) return {}
        const result: Record<string, { options: KbkItem[]; cascadeOptions: KbkItem[] }> = {}
        for (const item of (this.filterSettingsForm as any).incomes) {
            result[item.key] = this.getIncomeOptions(item.key)
        }
        return result
    }

    get cachedExpenseOptions(): Record<string, { options: KbkItem[]; cascadeOptions: KbkItem[] }> {
        if (!this.kbkOptions || !this.filterSettingsForm || !('expenses' in this.filterSettingsForm)) return {}
        const result: Record<string, { options: KbkItem[]; cascadeOptions: KbkItem[] }> = {}
        for (const item of (this.filterSettingsForm as any).expenses) {
            result[item.key] = this.getExpenseOptions(item.key)
        }
        return result
    }

    /**
     * Возвращает options и cascadeOptions для уровня экономической классификации (dict_ebk_ek).
     */
    public getEconOptions(levelKey: string): { options: KbkItem[]; cascadeOptions: KbkItem[] } {
        if (!this.kbkOptions) return { options: [], cascadeOptions: [] }
        const { paths, level_order, label_key_positions, labels, names_ru, names_kk } = this.kbkOptions
        if (!paths.econ || !level_order.econ) return { options: [], cascadeOptions: [] }
        const levelOrder = level_order.econ
        const levelPos = levelOrder.indexOf(levelKey)
        if (levelPos < 0) return { options: [], cascadeOptions: [] }

        const selectionsByPos = new Map<number, Set<number>>()
        if (this.filterSettingsForm && 'expenses' in this.filterSettingsForm) {
            for (const exp of (this.filterSettingsForm as any).expenses) {
                if (exp.key !== levelKey && exp.selected?.length > 0) {
                    const pos = levelOrder.indexOf(exp.key)
                    if (pos >= 0) selectionsByPos.set(pos, new Set(exp.selected))
                }
            }
        }

        const isEconCompatible = (p: (number | null)[]) => {
            for (const [pos, selected] of selectionsByPos) {
                const v = p[pos]
                if (v == null || !selected.has(v)) return false
            }
            return true
        }
        const cascadePaths = paths.econ.filter(p => p[levelPos] != null && isEconCompatible(p))
        const cascadeCodes = new Set<number>(cascadePaths.map(p => p[levelPos] as number))

        const selectedCodes = new Set<number>(
            (this.filterSettingsForm && 'expenses' in this.filterSettingsForm)
                ? ((this.filterSettingsForm as any).expenses.find((e: any) => e.key === levelKey)?.selected || [])
                : []
        )
        const extraPaths = paths.econ.filter(p => {
            const c = p[levelPos]
            return c != null && selectedCodes.has(c) && !cascadeCodes.has(c)
        })
        const relevantPaths = [...cascadePaths, ...extraPaths]

        const lkp = label_key_positions.econ[levelKey] ?? []
        const lbl = labels.econ[levelKey] ?? {}
        const options = this.buildKbkItems(paths.econ, levelKey, levelOrder, lkp, lbl, names_ru, names_kk, relevantPaths)
        const cascadeOptions = this.buildKbkItems(paths.econ, levelKey, levelOrder, lkp, lbl, names_ru, names_kk, cascadePaths)
        return { options, cascadeOptions }
    }

    get cachedEconOptions(): Record<string, { options: KbkItem[]; cascadeOptions: KbkItem[] }> {
        if (!this.kbkOptions || !this.filterSettingsForm || !('expenses' in this.filterSettingsForm)) return {}
        const result: Record<string, { options: KbkItem[]; cascadeOptions: KbkItem[] }> = {}
        for (const item of (this.filterSettingsForm as any).expenses) {
            result[item.key] = this.getEconOptions(item.key)
        }
        return result
    }

    get expensesHidden(): boolean {
        if (!this.isExpensesAvailable) {
            return false
        }

        if (this.filterSettingsForm?.key === 'SVOD-PLAN') {
            return this.filterSettingsForm.planType?.value === 'PF';
        } else {
            return (
                !!this.filterSettingsForm?.classificationType?.value &&  // Ensure it's a boolean (true/false)
                ['MIXED', 'EXPENSES'].includes(this.filterSettingsForm.classificationType.value) &&
                'expenses' in this.filterSettingsForm
            );
        }
    }

    get comparedPeriodHidden(): boolean {
        return this.filterSettingsForm?.key === "RECON-STATEMENT" && this.filterSettingsForm?.classificationType.value === 'EXPENSES';
    }
    // #endregion

    // #region Lifecycles
    private async created() {
        console.log('c-this.isNewForm', this.isNewForm)

        this.tempI18Service = i18nService
        try {
            this.loading = true

            this.setFacade()

            await this.setOblastKato()
            await this.setOblastCode()

            await this.setReportCategoryOptions()
            await this.setTemplateRegionOptions()
            this.setTemplateForm()

            await this.setTransfertOptions()
            await this.setFilterOptions()
            await this.setRegionOptionsOnCreate()
            this.setUserTypePfOptions()

            this.setFilterSettingsForm()

            this.loading = false
        } catch (error) {
            this.loading = true
            if (error instanceof Error) {
                makeToast(this, this.tr('toasts.' + error.message), this.tr('toasts.' + 'error'), 'danger')
                console.error(error.message)
            } else {
                makeToast(this, this.tr('toasts.' + 'load_error'), this.tr('toasts.' + 'error'), 'danger')
                console.error(error);
            }
        }
    }

    private beforeDestroy() {
        this.$emit("set-batch-export-params", null)
    }
    // #endregion

    // #region Methods
    /** Метод-обертка для $t */
    public tr(key: any): string {
        if (typeof key !== 'string') {
            return ''
        }

        const translationKey = 'modules.budget_execution_monitoring.reports_constructor'
        const text: string = String(this.$t(`${translationKey}.${key}`))

        return text
    }

    /**
     * Текст предупреждения об отсутствии среза кассового исполнения на отчётную дату
     * (RQ.58/RQ.59, §5.4) для отчёта DKI-R. Используется как в персистентном баннере над
     * таблицей результатов, так и (исторически) в тексте toast-уведомления.
     */
    public cashDateWarningToastText(warning: { requested: string; available: string | null }): string {
        const tableTranslationKey = 'modules.budget_execution_monitoring.reports_constructor.dki_r.table'
        const formatWarningDate = (value: string) => moment(value, 'YYYY-MM-DD').format('DD.MM.YYYY')
        if (warning.available) {
            return String(this.$t(`${tableTranslationKey}.cash_date_warning`))
                .replaceAll('$requested', formatWarningDate(warning.requested))
                .replaceAll('$available', formatWarningDate(warning.available))
        }
        return String(this.$t(`${tableTranslationKey}.cash_date_warning_no_data`))
    }

    private setFacade() {
        switch (this.template.filterSettings.reportName) {
            case 'PR2': this.facade = new Application2Facade(); break;
            case '1-27': this.facade = new Report127Facade(); break;
            case '1-27-DAILY': this.facade = new Report127DailyFacade(); break;
            case '4-20': this.facade = new Report420Facade(); break;
            case 'IRBO': this.facade = new ReportIRBOFacade(); break;
            case 'DVI': this.facade = new ReportDviFacade(); break;
            case 'IPIPM': this.facade = new ReportIPIPMFacade(); break;
            case '1-27-ACT': this.facade = new Report127ActFacade(); break;
            case 'DKI-R': this.facade = new ReportDkiRFacade(); break;
            case 'DKI-P': this.facade = new ReportDkiPFacade(); break;
            case 'EIB': this.facade = new ReportEibFacade(); break;
            case 'INCOME': this.facade = new ReportIncomeFacade(); break;
            case 'income_kbk': this.facade = new ReportPlanCashFacade(); break;
            case 'CASH-EXEC': this.facade = new ReportCashExecFacade(); break;
            case 'RS': this.facade = new ReportRsFacade(); break;
            case 'SVOD-PLAN': this.facade = new SvodPlanFacade(); break;
            case 'SVOD-DOH': this.facade = new SvodDohFacade(); break;
            case 'RT': this.facade = new ReportRtFacade(); break;
            case 'RECON-STATEMENT': this.facade = new ReportReconStatementFacade(); break;
            case 'BR': this.facade = new ReportBrFacade(); break;
            case 'MBSP': this.facade = new ReportMBSPFacade(); break;
            case 'LOAN-STATUS': this.facade = new LoanStatusFacade(); break;
            case 'RECON-PF-KF': this.facade = new ReconPfKfFacade(); break;
            case '2-43': this.facade = new Report243Facade(); break;
            case 'KSN': this.facade = new KsnFacade(); break;
            case 'SVOD-RAS': this.facade = new ReportSvodRasFacade(); break;
            case 'OWN-INCOME': this.facade = new ReportOwnIncomeFacade(); break;
            case 'SVOD-MB': this.facade = new SvodMbFacade(); break;
            case 'KF219-CO': this.facade = new Kf219CoFacade(); break;
            default: throw new Error('error_template_unsupported');
        }
    }


    private async setOblastKato() {
        const response = await fetch('/api/dict/server-description')
        if (!response.ok) {
            throw new Error('error_load_env_failed')
        }
        const serverDescription = await response.text()
        if (serverDescription === 'release' || this.$store.state._instanceCode === '') {
            this.oblastKato = '00'
        } else {
            this.oblastKato = this.$store.state._instanceCode
        }
    }

    private async setOblastCode() {
        const isTestOrNsi = this.oblastKato === '00' || this.oblastKato === '99'
        if (!isTestOrNsi) {
            const response = await fetch(`/api-py/monitoring/reports-constructor/tax-region/${this.oblastKato}`)
            if (!response.ok) {
                throw new Error('error_api_oblast_code')
            }
            const oblastCode = await response.json()
            this.oblastCode = oblastCode
        }
    }

    public onTemplateRegionInput(currentValues: Option<string>[] | Option<string>) {
        const allRegionCode = '000000'

        // 'Отдельные регионы' -> 'Все'
        if (Array.isArray(currentValues)) {
            const lastSelected = currentValues[currentValues.length - 1]
            if (lastSelected.value === allRegionCode) {
                this.isAllSelectedTemplateRegion = true
                this.templateForm.regions = { ...lastSelected }
            }
            return
        }

        // 'Все' -> 'Отдельные регионы'
        const isObjectButNotArray = typeof currentValues === "object" && currentValues !== null && !Array.isArray(currentValues)
        const fromAllToSeparateRegions = isObjectButNotArray && currentValues.value !== allRegionCode
        if (fromAllToSeparateRegions) {
            this.isAllSelectedTemplateRegion = false
            this.templateForm.regions = [currentValues]
        }
    }

    public onBackToTemplatesList() {
        this.$emit("set-journal-params", null)
        this.onSelectReport(null)
    }

    public onExpenseTypeInput(selectedOption: Option<ExpenseType>) {
        if (this.filterSettingsForm == null || !('expenses' in this.filterSettingsForm)) {
            return
        }

        if (selectedOption.value === 'FUNCTIONAL') {
            const emptyForm = this.facade!.getEmptyForm()
            if ('expenses' in emptyForm) {
                const functionalExpenseClassificators = emptyForm.expenses
                this.filterSettingsForm.expenses = functionalExpenseClassificators
            }
        } else if (selectedOption.value === 'ECONOMICAL') {
            const economicalClassificators = cloneDeep(allIncomeClassificators)
            this.filterSettingsForm.expenses = economicalClassificators
        } else {
            throw new Error('error_type_expense')
        }
    }

    private onExpenseInput(item: any) {
        const form = this.filterSettingsForm

        const key = form?.key;
        if (typeof key !== 'string' || !['SVOD-PLAN', 'RECON-STATEMENT'].includes(key) || item.key !== 'abp') {
            return;
        }

        if (form && 'region' in form && 'expenses' in form) {
            let dateOrYear: Date | number | null = null
            if ('year' in form && form.year) {
                dateOrYear = form.year
            } else if ('date' in form && form.date) {
                dateOrYear = form.date
            }

            this.getUserGu(form.region?.value??null, dateOrYear, form.expenses)
        }
    }

    // private filterGuByRegion(regionOptionsParam: any) {
    //     const regionVal = regionOptionsParam?.value;
    //     if (!regionVal) return [];

    //     const start2 = regionVal.slice(0, 2);
    //     const start4 = regionVal.slice(0, 4);

    //     if (regionVal.slice(2) === '0000') {
    //         return this.guList.filter((x: any) => x.region.slice(0, 2) === start2);
    //     }
    //     if (regionVal.slice(2) === '0101') {
    //         return this.guList.filter((x: any) => x.region.slice(0, 2) === start2 && x.budget_type === '02');
    //     }
    //     if (regionVal.slice(4) === '00') {
    //         return this.guList.filter((x: any) => x.region.slice(0, 4) === start4 && ['03', '06'].includes(x.budget_type));
    //     }
    //     if (regionVal.slice(4) === '01') {
    //         return this.guList.filter((x: any) =>
    //             x.region.slice(0, 4) === start4 &&
    //             x.region.slice(4, 6) === '01' &&
    //             ['03', '06'].includes(x.budget_type)
    //         );
    //     }
    //     return this.guList.filter((x: any) => x.region === regionVal && x.budget_type === '06');
    // }

    private calcOnCurPeriod = false;

    public setBudgetTypeFromRegion(regionOptionsParam: Option<string>[] | Option<string> | null) {
        let regionOptions: Option<string>[] | Option<string> = []

        if (regionOptionsParam) {
            regionOptions = regionOptionsParam
        }

        if (
            !this.filterSettingsForm
            || !this.filterOptions
            || !('budgetTypes' in this.filterOptions)
            || !('budgetTypes' in this.filterSettingsForm)
        ) {
            return
        }

        let regionOptionsArray: Option<string>[] = []
        if (Array.isArray(regionOptions)) {
            regionOptionsArray = regionOptions
        } else {
            regionOptionsArray = [regionOptions]
        }

        this.filterSettingsForm.budgetTypes = []
        // Проставить соответствующий budget_type
        const budgetTypes: BudgetType[] = []
        regionOptionsArray.forEach(regionOption => {
            const code: string = regionOption.value
            if (['302001', '301901', '300401'].includes(code) && this.template.filterSettings.reportName === 'PR2') {
                if (budgetTypes.notIncludes(3)) {
                    budgetTypes.push(3)
                }
            } else if (code.substring(2) === '0000') {
                if (budgetTypes.notIncludes(2)) {
                    budgetTypes.push(2)
                }
                if (budgetTypes.notIncludes(3)) {
                    budgetTypes.push(3)
                }
                if (budgetTypes.notIncludes(6)) {
                    budgetTypes.push(6)
                }
            } else if (code.substring(2) === '0100' && this.filterSettingsForm?.key === 'MBSP') {
                if (budgetTypes.notIncludes(2)) {
                    budgetTypes.push(2)
                }
                if (budgetTypes.notIncludes(3)) {
                    budgetTypes.push(3)
                }
                if (budgetTypes.notIncludes(6)) {
                    budgetTypes.push(6)
                }
            } else if (code.substring(4) === '00') {
                if (budgetTypes.notIncludes(3)) {
                    budgetTypes.push(3)
                }
                if (budgetTypes.notIncludes(6)) {
                    budgetTypes.push(6)
                }
            } else if (code.substring(2) === '0101') {
                if (budgetTypes.notIncludes(2)) {
                    budgetTypes.push(2)
                }
                if (this.filterSettingsForm?.key === 'MBSP') {
                    if (budgetTypes.notIncludes(3)) {
                        budgetTypes.push(3)
                    }
                }
            } else if (code.substring(4) === '01') {
                if (budgetTypes.notIncludes(3)) {
                    budgetTypes.push(3)
                }
                if (this.filterSettingsForm?.key === 'MBSP') {
                    if (budgetTypes.notIncludes(6)) {
                        budgetTypes.push(6)
                    }
                }
            } else if (code.substring(4) !== '01') {
                if (budgetTypes.notIncludes(6)) {
                    budgetTypes.push(6)
                }
                if (this.filterSettingsForm?.key === 'MBSP') {
                    if (budgetTypes.notIncludes(3)) {
                        budgetTypes.push(3)
                    }
                }
            }
        })

        const tempAllBudgetTypesOptions = cloneDeep(allBudgetTypesOptions)
        const tempOptions: Option<BudgetType>[] = []
        budgetTypes.sort((a: number, b: number) => a - b).forEach((budget: number) => {
            const budgetTypeOption = tempAllBudgetTypesOptions.find(item => item.value === budget)!
            tempOptions.push({...budgetTypeOption})
        })

        this.filterOptions.budgetTypes = tempAllBudgetTypesOptions.filter(it => budgetTypes.includes(it.value))
        this.filterSettingsForm.budgetTypes = tempOptions
    }

    public onRegionInput(regionOptionsParam: Option<string>[] | Option<string> | null) {
        // Reset sortByRegionCode when region changes - condition may no longer be met
        if (this.filterSettingsForm && 'sortByRegionCode' in this.filterSettingsForm) {
            this.filterSettingsForm.sortByRegionCode = false
        }
        // Common handles:
        if (this.filterSettingsForm && ("expenses" in this.filterSettingsForm || "incomes" in this.filterSettingsForm)) {
            this.loadKbkOptions()
        }
        if (this.filterSettingsForm && "transferts" in this.filterSettingsForm) {
            this.setTransfertOptions()
        }
        if (this.filterSettingsForm && 'senderbin' in this.filterSettingsForm) {
            this.set243ReportOptions()
        }
        if (Array.isArray(regionOptionsParam)) {
            this.filterMultipleSelectedRegions(regionOptionsParam)
        }
        this.setBudgetTypeFromRegion(regionOptionsParam)

        // Report-specific handles:
        if (this.filterSettingsForm?.key === 'IRBO' && !Array.isArray(regionOptionsParam)) {
            const lastFour = regionOptionsParam?.value.slice(2)
            const lastTwo = regionOptionsParam?.value.slice(4)

            const shouldDecodingActualRegionalBudgetCheckboxOnAndDisbled = (
                lastFour !== "0000" &&
                (
                    lastFour === "0101" ||
                    lastTwo === "00"
                )
            )
            if (shouldDecodingActualRegionalBudgetCheckboxOnAndDisbled) {
                this.filterSettingsForm.decodingActualRegionalBudget = shouldDecodingActualRegionalBudgetCheckboxOnAndDisbled
            }

            this.setMutuallyRedeemingLevelsFromRegion(regionOptionsParam ?? null)
        }

        // Set mutuallyRedeeming and mutuallyRedeemingLevels
        if (
            (
                (this.filterSettingsForm?.key === 'CASH-EXEC'
                && this.filterOptions?.key === 'CASH-EXEC')
                ||
                (this.filterSettingsForm?.key === 'RECON-STATEMENT'
                && this.filterOptions?.key === 'RECON-STATEMENT')
                ||
                (this.filterSettingsForm?.key === 'EIB'
                && this.filterOptions?.key === 'EIB')
                ||
                (this.filterSettingsForm?.key === 'SVOD-RAS'
                && this.filterOptions?.key === 'SVOD-RAS')
            )
            && !Array.isArray(regionOptionsParam)
        ) {
            const lastTwo = regionOptionsParam?.value.slice(4)
            if (lastTwo === '00') {
                this.filterSettingsForm.mutuallyRedeeming = cloneDeep(
                    this.filterOptions.mutuallyRedeeming.find(it => it.value === 'WITHOUT')!
                )
            } else {
                this.filterSettingsForm.mutuallyRedeeming = cloneDeep(
                    this.filterOptions.mutuallyRedeeming.find(it => it.value === 'WITH')!
                )
            }
            this.setMutuallyRedeemingLevelsFromRegion(regionOptionsParam ?? null)
        }

        // KF219-CO: "Взаимопогашаемые коды" по умолчанию "с ВЗК" и от региона не зависят (§3 ТЗ);
        // от региона зависят только доступные уровни ВЗК
        if (
            this.filterSettingsForm?.key === 'KF219-CO'
            && this.filterOptions?.key === 'KF219-CO'
            && !Array.isArray(regionOptionsParam)
        ) {
            this.setMutuallyRedeemingLevelsFromRegion(regionOptionsParam ?? null)
        }

        // DKI-R: отдельное, специфичное для отчёта правило дефолта ВЗК (RQ.eAk.RcDkiR.14).
        // Общее правило выше (суффикс "00") для DKI-R не подходит: "областной уровень бюджета"
        // в этом отчёте — это суффикс "0101" (город-центр области), а не "0000" (агрегатный
        // свод по области).
        if (
            this.filterSettingsForm?.key === 'DKI-R'
            && this.filterOptions?.key === 'DKI-R'
            && !Array.isArray(regionOptionsParam)
        ) {
            const regionCode = regionOptionsParam?.value
            if (regionCode) {
                const isOblastLevel = regionCode.slice(2) === '0101'
                this.filterSettingsForm.mutuallyRedeeming = cloneDeep(
                    this.filterOptions.mutuallyRedeeming.find(it => it.value === (isOblastLevel ? 'WITHOUT' : 'WITH'))!
                )
            }
            this.setMutuallyRedeemingLevelsFromRegion(regionOptionsParam ?? null)
        }

        if ((this.filterSettingsForm?.key === 'SVOD-PLAN' || this.filterSettingsForm?.key === 'RECON-PF-KF') && !Array.isArray(regionOptionsParam)) {
            this.setMutuallyRedeemingLevelsFromRegion(regionOptionsParam ?? null);
            this.getUserGu(regionOptionsParam?.value??null, this.filterSettingsForm.year, this.filterSettingsForm.expenses);
        }
        if (this.filterSettingsForm?.key === 'RECON-STATEMENT' && this.filterOptions?.key === 'RECON-STATEMENT' && !Array.isArray(regionOptionsParam)) {
            this.getUserGu(regionOptionsParam?.value??null, this.filterSettingsForm.year, this.filterSettingsForm.expenses);
        }
        if (this.filterSettingsForm?.key === 'BR' && this.filterOptions?.key === 'BR'  && !Array.isArray(regionOptionsParam)) {
            this.setMutuallyRedeemingLevelsFromRegion(regionOptionsParam ?? null)
        }
        if (this.filterSettingsForm?.key === 'RT' && this.filterOptions?.key === 'RT'  && !Array.isArray(regionOptionsParam)) {
            this.setMutuallyRedeemingLevelsFromRegion(regionOptionsParam ?? null)
        }
        if (this.filterSettingsForm?.key === 'MBSP' && this.filterOptions?.key === 'MBSP' && Array.isArray(regionOptionsParam)) {
            this.setMutuallyRedeemingLevelsFromRegions(regionOptionsParam ?? null)
        }
        if (this.filterSettingsForm?.key === 'DVI' && this.filterOptions?.key === 'DVI'  && !Array.isArray(regionOptionsParam)) {
            this.setMutuallyRedeemingLevelsFromRegion(regionOptionsParam ?? null)
        }
        if (this.filterSettingsForm?.key === 'SVOD-DOH' && this.filterOptions?.key === 'SVOD-DOH' && !Array.isArray(regionOptionsParam)) {
            this.setMutuallyRedeemingLevelsFromRegion(regionOptionsParam ?? null)
        }
    }

    public onSegmentationInput() {
        // Reset sortByRegionCode when segmentation changes - condition may no longer be met
        if (this.filterSettingsForm && 'sortByRegionCode' in this.filterSettingsForm) {
            this.filterSettingsForm.sortByRegionCode = false
        }
        this.resetIncomeInapplicableFlags()
        // Report-specific handles:
        if (this.filterSettingsForm?.key === '2-43') {
            if ('segmentations' in this.filterSettingsForm && this.filterSettingsForm.segmentations?.filter(it => it.value === 'SENDERBIN' && it.active).length === 0) {
                if ('topN' in this.filterSettingsForm && 'topNCount' in this.filterSettingsForm) {
                    this.filterSettingsForm.topN = false
                    this.filterSettingsForm.topNCount = null
                }
            }
        }
        // M-2: "Итого по региону" применим только пока разрез "Регион" активен (см.
        // isRegionsTotalCheckboxDisabled) - без сброса тумблер оставался включённым, но
        // недоступным для взаимодействия, после снятия разреза.
        if (this.filterSettingsForm?.key === 'SVOD-RAS' && 'regionsTotal' in this.filterSettingsForm) {
            const hasRegionSegmentation = this.filterSettingsForm.segmentations?.some(s => s.value === 'REGION' && s.active) ?? false
            if (!hasRegionSegmentation) {
                this.filterSettingsForm.regionsTotal = false
            }
        }
    }

    public onCertificateLevelInput(option: Option<CertificateLevel> | null) {
        if (this.filterSettingsForm?.key === 'RS') {
            this.filterSettingsForm.statuses = []
            this.filterSettingsForm.gus = []
            if (option?.value === 'GU') {
                this.loadRsGuList()
                this.loadRsGuStatuses()
            } else {
                this.rsGuList = []
                this.rsGuStatusOptions = []
            }
        }
    }

    public onSeparateByRegionChange(value: boolean) {
    }

    public onPlanByMonthsInput(value: boolean) {
        if (this.filterSettingsForm?.key === 'MBSP') {
            if (this.filterOptions && 'indicators' in this.filterOptions && 'indicators' in this.filterSettingsForm) {
                if (value) {
                    this.filterSettingsForm.indicators = cloneDeep(this.filterOptions.indicators)
                } else {
                    this.filterSettingsForm.indicators = cloneDeep(this.filterOptions.indicators.slice(0, 5))
                }
            }
        }
    }

    public onClassificationCheckboxChange(key: string, value: boolean, type: 'INCOME' | 'EXPENSE') {
        const form = this.filterSettingsForm as any
        if (type === 'EXPENSE') {
            // Две независимые связки: ФГ↔ФПГ и АБП↔БП. БПП и СПФ родителей не имеют.
            const EXPENSE_CHAINS: string[][] = [['gr', 'pgr'], ['abp', 'prg']]
            const chain = EXPENSE_CHAINS.find(c => c.includes(key))
            if (chain) {
                const keyIndex = chain.indexOf(key)
                form?.expenses?.forEach((it: any) => {
                    const i = chain.indexOf(it.key)
                    if (i < 0) return
                    if (value && i < keyIndex) it.active = true
                    if (!value && i > keyIndex) it.active = false
                })
            }
        }
        if (type === 'INCOME') {
            const incomeOrder = ['kat', 'cls', 'pcl', 'spf']
            const keyIndex = incomeOrder.indexOf(key)
            if (keyIndex >= 0) {
                form?.incomes?.forEach((it: any) => {
                    const i = incomeOrder.indexOf(it.key)
                    if (i < 0) return
                    if (value && i < keyIndex) it.active = true
                    if (!value && i > keyIndex) it.active = false
                })
            }
        }
    }

    /**
     * Применяет каскад чек-боксов к текущей форме (вызывается при открытии шаблона).
     * Если уровень активен, все его родители должны быть активны тоже.
     */
    public applyClassificationCascade() {
        const form = this.filterSettingsForm as any
        if (!form) return

        if (form.expenses) {
            const EXPENSE_CHAINS: string[][] = [['gr', 'pgr'], ['abp', 'prg']]
            for (const chain of EXPENSE_CHAINS) {
                // Находим максимальный активный индекс в цепочке
                let maxActiveIdx = -1
                form.expenses.forEach((it: any) => {
                    const i = chain.indexOf(it.key)
                    if (i >= 0 && it.active) maxActiveIdx = Math.max(maxActiveIdx, i)
                })
                // Все уровни до maxActiveIdx должны быть активны
                if (maxActiveIdx >= 0) {
                    form.expenses.forEach((it: any) => {
                        const i = chain.indexOf(it.key)
                        if (i >= 0 && i < maxActiveIdx) it.active = true
                    })
                }
            }
        }

        if (form.incomes) {
            const incomeOrder = ['kat', 'cls', 'pcl', 'spf']
            // Находим максимальный активный индекс
            let maxActiveIdx = -1
            form.incomes.forEach((it: any) => {
                const i = incomeOrder.indexOf(it.key)
                if (i >= 0 && it.active) maxActiveIdx = Math.max(maxActiveIdx, i)
            })
            // Все уровни до maxActiveIdx должны быть активны
            if (maxActiveIdx >= 0) {
                form.incomes.forEach((it: any) => {
                    const i = incomeOrder.indexOf(it.key)
                    if (i >= 0 && i < maxActiveIdx) it.active = true
                })
            }
        }
    }

    public setMutuallyRedeemingLevelsFromRegion(regionOption: Option<string> | null) {
        // 2-43: уровни ВЗК не зависят от региона, по умолчанию не отмечены
        if (this.filterSettingsForm?.key === '2-43') {
            return
        }
        if (
            !regionOption
            || !this.filterSettingsForm
            || !this.filterOptions
            || !('mutuallyRedeemingLevels' in this.filterSettingsForm)
            || !('mutuallyRedeemingLevels' in this.filterOptions)
        ) {
            return
        }

        const region = regionOption.value

        const lastFour = region.slice(2)
        const lastTwo = region.slice(4)
        if (lastFour === '0000' || lastFour === "0101") {
            this.filterSettingsForm.mutuallyRedeemingLevels = this.filterOptions.mutuallyRedeemingLevels
                .filter(it => ['TYPE-3', 'TYPE-4'].includes(it.value))
        } else if (lastTwo === '00' || lastTwo === '01') {
            this.filterSettingsForm.mutuallyRedeemingLevels = this.filterOptions.mutuallyRedeemingLevels
                .filter(it => it.value === 'TYPE-4')
        } else {
            this.filterSettingsForm.mutuallyRedeemingLevels = this.filterOptions.mutuallyRedeemingLevels
                .filter(it => ['TYPE-3', 'TYPE-4'].includes(it.value))
        }
    }


    public setMutuallyRedeemingLevelsFromRegions(regionOption: Option<string>[] | null) {
        // 2-43: уровни ВЗК не зависят от региона, по умолчанию не отмечены
        if (this.filterSettingsForm?.key === '2-43') {
            return
        }
        if (
            !regionOption
            || !this.filterSettingsForm
            || !this.filterOptions
            || !('mutuallyRedeemingLevels' in this.filterSettingsForm)
            || !('mutuallyRedeemingLevels' in this.filterOptions)
        ) {
            return
        }

        const regionsSecond = regionOption.filter(x => (x.value.slice(2, 4) !== '00' && x.value.slice(2, 4) !== '01') && x.value.slice(4) === '00');
        if (this.filterSettingsForm?.key === 'MBSP' && this.filterOptions?.key === 'MBSP') {
            let oblastIn:boolean = false
            let rayonIn:boolean = false
            if (regionOption.find(x => x.value.slice(2) === '0101')) {
                oblastIn = true
            }
            if (regionOption.find(x => (!['0101', '0000'].includes(x.value.slice(2))) && (x.value.slice(4) === '00' || x.value.slice(4) === '01'))) {
                rayonIn = true
            }
            if (regionOption.find(x => ['0100', '0000'].includes(x.value.slice(2)))) {
                oblastIn = true
                rayonIn = true
            }
            this.filterSettingsForm.mutuallyRedeemingLevels = this.filterOptions.mutuallyRedeemingLevels
                .filter(it => (((it.value === 'TYPE-4' && rayonIn) || (it.value === 'TYPE-3' && oblastIn)) && (rayonIn || oblastIn)) || (it.value === 'TYPE-4' && !(rayonIn || oblastIn)))
            return;
        }
        if (regionsSecond.length > 0) {
            this.filterSettingsForm.mutuallyRedeemingLevels = this.filterOptions.mutuallyRedeemingLevels
                .filter(it => it.value === 'TYPE-4')
        } else {
            this.filterSettingsForm.mutuallyRedeemingLevels = this.filterOptions.mutuallyRedeemingLevels
                            .filter(it => ['TYPE-3', 'TYPE-4'].includes(it.value))
        }
    }

    public filterMultipleSelectedRegions(regionOptions: Option<string>[]) {
        if (!this.filterSettingsForm || !('regions' in this.filterSettingsForm)) {
            return
        }

        this.setMutuallyRedeemingLevelsFromRegions(regionOptions ?? null)

        const entireOblasts = regionOptions.filter(it => {
            const lastFour = it.value.slice(2)
            return lastFour === '0000'
        })
        if (entireOblasts.length > 0) {
            this.filterSettingsForm.regions = cloneDeep(entireOblasts)
            return
        }
        if (this.filterSettingsForm?.key === 'MBSP' && this.filterOptions?.key === 'MBSP') {
            const oblast00 = regionOptions.filter(it => {
                const lastFour = it.value.slice(2)
                return lastFour === '0100'
            })
            if (oblast00.length > 0) {
                this.filterSettingsForm.regions = cloneDeep(oblast00)
                return
            }

            const region00 = regionOptions.filter(it => {
                const lastTwo = it.value.slice(4)
                return lastTwo === '00'
            })
            if (region00.length > 0) {
                const oblasts = regionOptions.filter(it => {
                    const lastFour = it.value.slice(2)
                    return lastFour === '0101'
                })
                this.filterSettingsForm.regions = cloneDeep(region00.concat(oblasts))
                return
            }

            const oblast = regionOptions.filter(it => {
                const lastTwo = it.value.slice(4)
                return lastTwo === '01'
            })
            if (oblast.length > 0) {
                this.filterSettingsForm.regions = cloneDeep(oblast)
                return
            }


        }

        const entireRaiyons = regionOptions.filter(it => {
            const lastTwo = it.value.slice(4)
            return lastTwo === '00'
        })
        if (entireRaiyons.length > 0) {
            const firstFours = entireRaiyons.map(it => it.value.substring(0, 4))
            const entireRaiyonCodes = entireRaiyons.map(it => it.value)
            this.filterSettingsForm.regions = cloneDeep(
                regionOptions.filter(it => !firstFours.includes(it.value.substring(0, 4)) || entireRaiyonCodes.includes(it.value))
            )
            return
        }
    }

    public async onYearChange() {
        if (!this.filterSettingsForm) {
            return
        }
        if (!('periodicity' in this.filterSettingsForm)) {
            return
        }
        switch (this.filterSettingsForm.periodicity.value) {
            case 'QUARTER':
                await this.onYearOrQuarterChange()
                break
            case 'MONTH':
                await this.onMonthInput()
                break
            default:
        }
    }

    @Watch('filterSettingsForm.year', { deep: true })
    @Watch('filterSettingsForm.month', { deep: true })
    @Watch('filterSettingsForm.regions', { deep: true })
    @Watch('filterSettingsForm.budgetTypes', { deep: true })
    @Watch('filterSettingsForm.year', { deep: true })
    @Watch('filterSettingsForm.measureUnit', { deep: true })
    @Watch('filterSettingsForm.roundUp', { deep: true })
    @Watch('filterSettingsForm.roundUpTo', { deep: true })
    @Watch('filterSettingsForm.classificationType', { deep: true })
    onBatchExportParamsChange() {
        if (this.isBatchExportTemplate) {
            this.setBatchExportParams()
        }
    }

    @Watch('datePeriod')
    async onDatePeriodChange() {
        if (this.filterSettingsForm?.key === 'SVOD-PLAN') {
            await this.getStatusList()
        }
    }

    @Watch('filterSettingsForm.region', { deep: true })
    @Watch('filterSettingsForm.periodFrom')
    @Watch('filterSettingsForm.periodTo')
    @Watch('filterSettingsForm.expenses', { deep: true })
    private async onRsGuDepsChange() {
        if (this.filterSettingsForm?.key === 'RS' && this.filterSettingsForm.certificateLevel?.value === 'GU') {
            await this.loadRsGuList()
        }
    }

    @Watch('filterSettingsForm.region', { deep: true })
    @Watch('filterSettingsForm.periodFrom')
    @Watch('filterSettingsForm.periodTo')
    private async onRsGuStatusDepsChange() {
        if (this.filterSettingsForm?.key === 'RS' && this.filterSettingsForm.certificateLevel?.value === 'GU') {
            await this.loadRsGuStatuses()
        }
    }

    @Watch('filterSettingsForm', { deep: true })
    onFilterSettingsFormChange() {
        // SVOD-PLAN
        if (this.filterSettingsForm?.key === 'SVOD-PLAN' && this.facade instanceof SvodPlanFacade) {
            let request: ReportSvodPlanTableDataRequest | undefined = undefined
            try {
                const form = cloneDeep(this.filterSettingsForm)

                const incomesOrder: Record<string, number> = {
                    'kat': 0,
                    'cls': 1,
                    'pcl': 2,
                    'spf': 3,
                }
                form.incomes = form.incomes
                    .sort((a, b) => incomesOrder[a.key] - incomesOrder[b.key]) // kat to spf
                    .map(it => ({
                        key: it.key,
                        selected: it.selected,
                        active: true
                    }))
                if (!this.isIncomesAvailable) {
                    form.incomes = []
                }

                const expensesOrder: Record<string, number> = {
                    'gr': 0,
                    'pgr': 1,
                    'abp': 2,
                    'prg': 3,
                    'ppr': 4,
                    'spf': 5,
                }
                form.expenses = form.expenses
                    .filter(it => {
                        if (it.key === 'gr' || it.key === 'pgr') {
                            return it.active
                        }
                        return true
                    })
                    .sort((a, b) => expensesOrder[a.key] - expensesOrder[b.key]) // gr to spf
                    .map(it => ({
                        key: it.key,
                        selected: it.selected,
                        active: true
                    }))

                this.setIncomeExpenseToPassAndUserAvailableKbks(form)
                request = this.facade.constructDataRequest(form, this.userId)
            } catch (error) {}
            this.setBatchExportParams(request)
        }
    }

    @Watch('filterSettingsForm.classificationType', { deep: true })
    @Watch('filterSettingsForm.dataSource', { deep: true })
    @Watch('filterSettingsForm.byForm', { deep: true })
    @Watch('filterSettingsForm.planType', { deep: true })
    @Watch('filterSettingsForm.typePF', { deep: true })
    onParamsChangeCachExec() {
        if (this.filterSettingsForm?.key === 'RECON-STATEMENT' && this.filterOptions?.key === 'RECON-STATEMENT') {
            if ('periodicity' in this.filterSettingsForm) {
                if (this.filterSettingsForm.classificationType?.value === 'INCOMES') {
                    this.filterSettingsForm.periodicity.value = 'MONTH'
                    this.filterSettingsForm.segmentations = cloneDeep(this.filterOptions.segmentations.filter(it => it.value !== 'GU'))
                } else {
                    this.filterSettingsForm.periodicity.value = 'DAY'
                    this.filterSettingsForm.segmentations = cloneDeep(this.filterOptions.segmentations)
                }
            }
        }
        if (this.filterSettingsForm?.key === 'SVOD-PLAN' && this.filterOptions?.key === 'SVOD-PLAN') {
            // Наблюдатель срабатывает и при открытии шаблона (форма подменяется целиком), поэтому
            // уже выбранную разрезность не сбрасываем: убираем недоступные элементы, порядок и активность остальных сохраняем
            const current = this.filterSettingsForm.segmentations ?? []
            const keepSelected = (allowed: typeof current) => {
                const kept = current.filter(it => allowed.some(a => a.value === it.value))
                return [...cloneDeep(kept), ...cloneDeep(allowed.filter(a => !kept.some(k => k.value === a.value)))]
            }
            if (this.filterSettingsForm.planType.value === 'PP') {
                this.filterSettingsForm.segmentations = keepSelected(this.filterOptions.segmentations.filter(it => it.value !== 'GU'))
            } else {
                if (this.filterSettingsForm.typePF.value === 'PF') {
                    this.filterSettingsForm.segmentations = keepSelected(this.filterOptions.segmentations.filter(it => it.value !== 'REGION'))
                } else if (this.filterSettingsForm.typePF.value === 'SPF') {
                    this.filterSettingsForm.segmentations = keepSelected(this.filterOptions.segmentations)
                } else if (this.filterSettingsForm.typePF.value === 'IPF') {
                    const ipfSegmentations = []
                    const guItem = cloneDeep(this.filterOptions.segmentations.find(it => it.value === 'GU'))
                    if (guItem) {
                        guItem.active = true
                        ipfSegmentations.push(guItem)
                    }
                    const kbkItem = cloneDeep(this.filterOptions.segmentations.find(it => it.value === 'KBK'))
                    if (kbkItem) {
                        kbkItem.active = true
                        ipfSegmentations.push(kbkItem)
                    }
                    this.filterSettingsForm.segmentations = ipfSegmentations
                } else {
                    this.filterSettingsForm.segmentations = []
                }
            }
        }
    }
    @Watch('filterSettingsForm.classificationType', { deep: true })
    private onParamsChangedReconStatement() {
        if (this.filterSettingsForm?.key === 'RECON-STATEMENT' && this.filterOptions?.key === 'RECON-STATEMENT') {

            const filterOptions1:FilterOptions = this.facade!.getFilterOptions()

            if (filterOptions1 && this.filterSettingsForm.classificationType?.value === 'INCOMES') {
                this.filterOptions.dataSources = filterOptions1.dataSources.filter(it => it.value === 'LOADER')
            } else {
                this.filterOptions.dataSources = filterOptions1.dataSources.filter(it => it.value !== 'MIXED')
            }
            if (this.filterOptions.dataSources.length) {
                this.filterSettingsForm.dataSource = this.filterOptions.dataSources[0]
            }
            let date: Date | null = null
            let strDate = ''
            if (this.filterSettingsForm.classificationType?.value === 'INCOMES') {
                strDate = getLastDateOfMonth(this.filterSettingsForm.year, this.filterSettingsForm.month.value)
            } else {
                date = this.filterSettingsForm.date
                if (date) {
                    strDate = moment(date).format('YYYY-MM-DD')
                }
            }
            if (strDate) {
                this.datePeriod = strDate
            }
            this.onRegionInput(this.filterSettingsForm.region)
        }
    }

    @Watch('filterSettingsForm.classificationType', { deep: true })
    @Watch('filterSettingsForm.compared_period', { deep: true })
    private changeComparedPeriod() {
        if (this.filterSettingsForm?.key === 'RECON-STATEMENT' && this.filterOptions?.key === 'RECON-STATEMENT') {
            if (this.filterSettingsForm.classificationType?.value === 'INCOMES') {
                this.filterSettingsForm.indicators = cloneDeep(reportReconStatementIncomeIndicators)
            } else {
                if (this.filterSettingsForm?.compared_period.value === 'YEAR') {
                    this.filterSettingsForm.indicators = cloneDeep(reportReconStatementExpenseIndicators).filter(v => !['obaz', 'plat'].includes(v.key))
                } else if (this.filterSettingsForm?.compared_period.value === 'MONTH') {
                    this.filterSettingsForm.indicators = cloneDeep(reportReconStatementExpenseIndicators).filter(v => !['plg', 'is_equal'].includes(v.key))
                } else {
                    this.filterSettingsForm.indicators = cloneDeep(reportReconStatementExpenseIndicators).filter(v => !['is_equal'].includes(v.key))
                }
            }
        }
    }

    // 1-27-DAILY: если КБК не в разрезности — деактивировать все классификации КБК и установить budget_structure = 'WITHOUT'
    @Watch('filterSettingsForm.segmentations', { deep: true })
    private onDailySegmentationsChange() {
        if (this.filterSettingsForm?.key !== '1-27-DAILY') return
        if (!('segmentations' in this.filterSettingsForm)) return
        const activeSegmentations = this.filterSettingsForm.segmentations.filter(s => s.active)
        const kbkNotActive = activeSegmentations.length > 0 && !activeSegmentations.some(s => s.value === 'KBK')
        if (kbkNotActive) {
            // Деактивировать все КБК чекбоксы
            this.filterSettingsForm.incomes.forEach(it => { it.active = false })
            this.filterSettingsForm.expenses.forEach(it => { it.active = false })
            // Установить budget_structure = 'WITHOUT'
            if ('budgetStructure' in this.filterSettingsForm && this.filterOptions && 'budgetStructures' in this.filterOptions) {
                const withoutOption = this.filterOptions.budgetStructures.find(it => it.value === 'WITHOUT')
                if (withoutOption) {
                    this.filterSettingsForm.budgetStructure = { ...withoutOption }
                }
            }
        }
    }

    @Watch('filterSettingsForm.budgetTypes', { deep: true })
    private onBudgetTypesChange() {
        if (
            this.filterSettingsForm?.key === 'IPIPM'
            && this.filterOptions?.key === 'IPIPM'
            && this.template.id === null
            && 'indicators' in this.filterSettingsForm
            && 'indicators' in this.filterOptions
            && 'budgetTypes' in this.filterSettingsForm
        ) {
            const types = this.filterSettingsForm.budgetTypes.map(b => b.value)
            const allowed: Partial<Record<BudgetType, string[]>> = {
                2: ['rb', 'nf', 'mb', 'vz'],
                3: ['rb', 'nf', 'ob', 'mb', 'vz'],
                6: ['rb', 'nf', 'ob', 'mb', 'vz', 'br'],
            }
            const suffixes = new Set(types.flatMap(t => allowed[t] ?? []))
            this.filterSettingsForm.indicators = cloneDeep(this.filterOptions.indicators).filter(ind => {
                const suffix: string|undefined = ['rb', 'nf', 'ob', 'mb', 'vz', 'br'].find(s => ind.key.endsWith(`_${s}`))
                const isFiltered = suffix && ['history', 'plan', 'fact', 'remain_plan'].some(p => ind.key.startsWith(p))
                return isFiltered && suffix !== undefined ? suffixes.has(suffix) : true
            })
        }
    }

    private setBatchExportParams(params?: any) {
        let batchExportParams: BatchExportRequest | null = null

        if (this.filterSettingsForm?.key === '1-27') {
            const year = this.filterSettingsForm.year
            const month = this.filterSettingsForm.month?.value
            const regions = this.filterSettingsForm.regions.map(it => it.value)
            const budgetTypes = this.filterSettingsForm.budgetTypes.map(it => it.value)
            const measureUnit = this.filterSettingsForm.measureUnit?.value

            let roundUpTo: number | null = null
            if (this.filterSettingsForm.roundUp) {
                roundUpTo = this.filterSettingsForm.roundUpTo ?? null
            }

            if (!year || !month || !measureUnit || regions.length === 0 || budgetTypes.length === 0) {
                this.$emit("set-batch-export-params", null)
                return
            }

            const tempRequest: Report127BatchExportRequest = {
                key: '1-27',

                year: year,
                month: month,
                regions: regions,
                budget_types: budgetTypes,
                measure_unit: measureUnit,
                round_up_to: roundUpTo,
                locale: i18nService.locale,
                is_tree: this.filterSettingsForm.isTree,
                user_id: this.userId
            }
            batchExportParams = tempRequest
        } else if (this.filterSettingsForm?.key === 'RS') {
            const isUoUser = this.userAccessLevels['is_oblast_uo']
                || this.userAccessLevels['is_raion_uo']
                || this.userAccessLevels['is_msu_uo']
                || this.userAccessLevels['is_techsupport_or_consultant']
            if (!isUoUser) {
                this.$emit("set-batch-export-params", null)
                return
            }
            // TODO: set predetermined classificators
            if (params) {
                const incomesOrder: Record<string, number> = {
                    'kat': 0,
                    'cls': 1,
                    'pcl': 2,
                    'spf': 3,
                }
                params.incomes = this.filterSettingsForm.incomes
                    .sort((a, b) => incomesOrder[a.key] - incomesOrder[b.key])
                    .map(it => ({
                        key: it.key,
                        selected: it.selected
                    }))

                const expensesOrder: Record<string, number> = {
                    'gr': 0,
                    'pgr': 1,
                    'abp': 2,
                    'prg': 3,
                    'ppr': 4,
                    'spf': 5,
                }
                params.expenses = this.filterSettingsForm.expenses
                    .filter(it => it.key !== 'pgr')
                    .sort((a, b) => expensesOrder[a.key] - expensesOrder[b.key])
                    .map(it => ({
                        key: it.key,
                        selected: it.selected // TODO: pass selected as firstly passed in constructReport method
                    }))

                const guItem = {
                    key: 'gu',
                    selected: []
                }
                const index = params.expenses.findIndex((it: any) => it.key === 'abp')
                if (index !== -1) {
                    params.expenses.splice(index + 1, 0, guItem)
                }

                if (params.region && params.region.substring(2) !== '0000') {
                    batchExportParams = params
                    // @ts-ignore
                    batchExportParams.key = 'RS'
                }
            }
        } else if (this.filterSettingsForm?.key === 'SVOD-PLAN') {
            const typeParams = params as ReportSvodPlanTableDataRequest | undefined

            if (
                typeParams
                && typeParams.region
                && typeParams.region.substring(2) !== '0000'
                && typeParams.region.substring(2) !== '0100'
                && typeParams.svod_type === 'SCORR'
                && (typeParams.statuses.includes('26') || typeParams.statuses.includes('39'))
                && typeParams.plan_type === 'PF'
            ) {
                batchExportParams = params
                // @ts-ignore
                batchExportParams.key = 'SVOD-PLAN'
            }
        }

        this.$emit("set-batch-export-params", batchExportParams)
    }

    public async onYearInput(year: number | null) {
        if (this.filterSettingsForm == null || this.filterOptions == null) {
            return
        }

        if ('regions' in this.filterOptions) {
            this.datePeriod = null
            if (!year) {
                return
            }
            this.datePeriod = `${year}-01-01`
            await this.setRegionOptions()
            if ('region' in this.filterSettingsForm) {
                // @ts-ignore
                const region = this.filterSettingsForm.region as Option<string> | null
                this.setBudgetTypeFromRegion(region)
                if ('expenses' in this.filterSettingsForm) {
                    this.getUserGu(region?.value??null, new Date(`${year}-01-01`), this.filterSettingsForm.expenses)
                }
            }
            if ('regions' in this.filterSettingsForm) {
                // @ts-ignore
                const regions: Option<string>[] = this.filterSettingsForm.regions as Option<string>[]
                this.setBudgetTypeFromRegion(regions)
            }
        }
    }

    onMutuallyRedeemingInput(option: Option<MutuallyRedeeming> | null) {
        // 2-43: при «с ВЗК» отмеченные уровни ВЗК сбрасываются
        if (this.filterSettingsForm?.key === '2-43' && option?.value === 'WITH') {
            this.filterSettingsForm.mutuallyRedeemingLevels = []
        }
    }

    async onBudgetTypeInput(option: Option<BudgetType> | null) {
        if (this.filterSettingsForm?.key === 'LOAN-STATUS') {
            this.setCreditorOptions(option?.value??null, this.filterSettingsForm.date)
        }
    }

    createDebouncedOnYearInput() {
        const that = this
        return debounce(async function (year: number | null) {
            await that.onYearInput(year)
        }, 300)
    }
    debouncedOnYearInput = this.createDebouncedOnYearInput()

    debouncedSetTransfertOptions = debounce(() => this.setTransfertOptions(), 300)

    public async onYearOrQuarterChange() {
        if (this.filterSettingsForm == null || this.filterOptions == null) {
            return
        }
        if (!('quarter' in this.filterSettingsForm)) {
            return
        }
        if (!('regions' in this.filterOptions)) {
            return
        }
        if (!this.filterSettingsForm.quarter?.value) {
            return
        }

        this.datePeriod = null

        const year = this.filterSettingsForm.year
        const quarter = this.filterSettingsForm.quarter.value
        if (!year || !quarter) {
            return
        }
        this.datePeriod = getLastDateOfQuarter(year, quarter)
        await this.setRegionOptions()
        if ('region' in this.filterSettingsForm) {
            // @ts-ignore
            const region = this.filterSettingsForm.region as Option<string> | null
            this.setBudgetTypeFromRegion(region)
        }
        if ('regions' in this.filterSettingsForm) {
            // @ts-ignore
            const regions: Option<string>[] = this.filterSettingsForm.regions as Option<string>[]
            this.setBudgetTypeFromRegion(regions)
        }
    }

    public async onMonthInput() {
        if (this.filterSettingsForm == null || this.filterOptions == null || !('regions' in this.filterOptions) || !('month' in this.filterSettingsForm)) {
            return
        }

        this.datePeriod = null
        const year = this.filterSettingsForm.year
        const month = (this.filterSettingsForm.month as (Option<number> | undefined))?.value
        if (!year || !month) {
            return
        }
        this.datePeriod = getLastDateOfMonth(year, month)
        await this.setRegionOptions()
        if ('region' in this.filterSettingsForm) {
            // @ts-ignore
            const region = this.filterSettingsForm.region as Option<string> | null
            this.setBudgetTypeFromRegion(region)
        }
        if ('regions' in this.filterSettingsForm) {
            // @ts-ignore
            const regions: Option<string>[] = this.filterSettingsForm.regions as Option<string>[]
            this.setBudgetTypeFromRegion(regions)
        }
    }

    public async onDateChange() {
        if (this.filterSettingsForm && "transferts" in this.filterSettingsForm) {
            this.setTransfertOptions()
        }

        if (
            this.filterSettingsForm == null
            || this.filterOptions == null
            || !('regions' in this.filterOptions)
            || !('region' in this.filterSettingsForm || 'regions' in this.filterSettingsForm)
        ) {
            if (this.filterSettingsForm?.key !== 'INCOME') { // TODO: Why <this.filterSettingsForm?.key !== 'INCOME'>
                return
            }
        }

        let date: Date | null = null
        if ('date' in this.filterSettingsForm) {
            date = this.filterSettingsForm.date
        } else if ('periodTo' in this.filterSettingsForm) {
            date = this.filterSettingsForm.periodTo
        } else if ('edate' in this.filterSettingsForm) {
            date = (this.filterSettingsForm as any).edate
        }

        this.datePeriod = null
        if (!date && this.filterSettingsForm?.key !== 'INCOME') { // TODO: Why <this.filterSettingsForm?.key !== 'INCOME'>
            if ('region' in this.filterSettingsForm) {
                this.filterSettingsForm.region = null
            }
            if ('regions' in this.filterSettingsForm) {
                this.filterSettingsForm.regions = []
            }
            if (this.filterOptions && 'regions' in this.filterOptions) {
                this.filterOptions.regions = []
            }
            return
        }

        const strDate = moment(date).format('YYYY-MM-DD')
        this.datePeriod = strDate
        await this.setRegionOptions();
        if ('region' in this.filterSettingsForm) {
            // @ts-ignore
            const region = this.filterSettingsForm.region as Option<string> | null
            this.setBudgetTypeFromRegion(region)
        }
        if ('regions' in this.filterSettingsForm) {
            // @ts-ignore
            const regions: Option<string>[] = this.filterSettingsForm.regions as Option<string>[]
            this.setBudgetTypeFromRegion(regions)
        }
        if (this.filterSettingsForm && 'senderbin' in this.filterSettingsForm) {
            await this.set243ReportOptions()
        }
    }

    private async loadSuppliers() {
        if (this.filterSettingsForm?.key !== 'BR') return
        if (!this.isSupplierFilterEnabled) {
            this.brSupplierOptions = []
            if (this.filterSettingsForm && 'suppliers' in this.filterSettingsForm) {
                (this.filterSettingsForm as any).suppliers = []
            }
            if (this.filterOptions && 'suppliers' in this.filterOptions) {
                (this.filterOptions as any).suppliers = []
            }
            return
        }
        const f = this.filterSettingsForm as any
        const strDate = moment(f.date).format('YYYY-MM-DD')
        const region = f.region.value
        const budgetTypes = f.budgetTypes.map((b: any) => b.value).join(',')
        const developType = f.developType.value ?? ''
        try {
            const resp = await fetch(
                `/api-py/monitoring/reports-constructor/br-suppliers?date=${strDate}&region=${region}&budget_types=${budgetTypes}&develop_type=${developType}`
            )
            if (!resp.ok) return
            const data: { value: string; label: string }[] = await resp.json()
            this.brSupplierOptions = data
            if (this.filterOptions && 'suppliers' in this.filterOptions) {
                (this.filterOptions as any).suppliers = data
            }
            // оставляем только те выбранные, которые есть в новом списке
            if (this.filterSettingsForm && 'suppliers' in this.filterSettingsForm) {
                const validValues = new Set(data.map(d => d.value))
                ;(this.filterSettingsForm as any).suppliers = (this.filterSettingsForm as any).suppliers.filter(
                    (s: any) => validValues.has(s.value)
                )
            }
        } catch {
            // silently ignore
        }
    }

    @Watch('filterSettingsForm.date')
    @Watch('filterSettingsForm.region')
    @Watch('filterSettingsForm.budgetTypes', { deep: true })
    @Watch('filterSettingsForm.developType')
    private async onBrSupplierDepsChange() {
        if (this.filterSettingsForm?.key === 'BR') {
            await this.loadSuppliers()
        }
    }

    public async onDateInput(date: Date | null) {
        await this.onDateChange()

        const key = this.filterSettingsForm?.key
        if (date && (key === 'INCOME' || key === 'income_kbk') && this.filterSettingsForm && 'incomes' in this.filterSettingsForm) {
            const defaultKat = date.getFullYear() >= 2026 ? [1, 2, 3, 4] : [1, 2, 3]
            const katItem = (this.filterSettingsForm.incomes as any[]).find((it: any) => it.key === 'kat')
            if (katItem) {
                katItem.selected = defaultKat
            }
        }

        if (this.filterSettingsForm?.key === 'LOAN-STATUS') {
            if (date) {
                const strDate: string = moment(date).format('YYYY-MM-DD')
                this.setLoanPurposeOptions(strDate)
            }

            this.setCreditorOptions(this.filterSettingsForm.budgetType?.value??null, date)
        }
    }
    public onPeriodInput(period: string) {
        if (this.filterSettingsForm?.key === '2-43') {
            if ('periodTo' in this.filterSettingsForm && 'periodFrom' in this.filterSettingsForm && 'periodPrevTo' in this.filterSettingsForm && 'periodPrevFrom' in this.filterSettingsForm) {
                const periodFrom: Date = this.filterSettingsForm.periodFrom
                const periodTo: Date = this.filterSettingsForm.periodTo

                const year = periodFrom.getFullYear()
                const monthFrom = periodFrom.getMonth()
                const monthTo = this.filterSettingsForm.periodTo.getMonth()
                const yearPrev = year - 1
                if (period === 'periodFrom') {
                    if (this.filterSettingsForm.periodTo.getFullYear() !== year) {
                        this.filterSettingsForm.periodTo = new Date(year, monthTo, periodTo.getDate())
                    }
                    this.filterSettingsForm.periodPrevFrom = new Date(yearPrev, monthFrom, periodFrom.getDate())
                    if (this.filterSettingsForm.periodPrevFrom.getMonth() !== monthFrom) {
                        this.filterSettingsForm.periodPrevFrom = new Date(yearPrev, monthFrom + 1, 0)
                    }
                }
                this.filterSettingsForm.periodPrevTo = new Date(yearPrev, monthTo, 0)
                if (this.filterSettingsForm.periodPrevTo.getMonth() !== monthTo) {
                    this.filterSettingsForm.periodPrevTo = new Date(yearPrev, monthTo + 1, 0)
                }
            }
        }
    }
    public onClassificationTypeInput(type: Option<ClassificationType> | null) {
        if (this.filterSettingsForm?.key === 'CASH-EXEC' && this.filterOptions?.key === 'CASH-EXEC') {
            // Indicators
            if (type?.value === 'INCOMES') {
                this.filterSettingsForm.indicators = cloneDeep(reportCashExecIncomeIndicators)
            } else if (type?.value === 'EXPENSES') {
                this.filterSettingsForm.indicators = cloneDeep(reportCashExecExpenseIndicators)
            }

            // byForms
            if (type?.value === 'INCOMES') {
                this.filterSettingsForm.byForm = cloneDeep(this.filterOptions.byForms.find(it => it.value === '2-19')!)
            } else if (type?.value === 'EXPENSES') {
                this.filterSettingsForm.byForm = cloneDeep(this.filterOptions.byForms.find(it => it.value === '4-20')!)
            }
            this.setSegmentationsOptions()
            return
        }

        if (this.filterSettingsForm?.key === 'RS') {
            this.filterSettingsForm.certificateTypes = cloneDeep(this.certificateTypeOptions)
            return
        }
    }

    public onByFormInput(byForm: Option<ByForm> | null) {
        this.setSegmentationsOptions()
    }

    public onDataSourceInput(dataSource: Option<DataSource> | null) {
        this.setSegmentationsOptions()
    }

    public onDataSource2Input(dataSource: Option<DataSource> | null) {
        if (this.filterSettingsForm?.key === 'CASH-EXEC' && this.filterOptions?.key === 'CASH-EXEC') {
            if (this.byFormFilterOptions.length) {
                this.filterSettingsForm.byForm = this.byFormFilterOptions[0]
            }
        }
    }



    public async onByBudgetLevelChange(value: boolean) {
        if (!this.tableData || !this.journalParams || this.journalParams.reportName !== '2-43') {
            return
        }
        const journalParams = cloneDeep(this.journalParams)
        journalParams.params.by_budget_level = value
        ;(journalParams.filter_settings as any).byBudgetLevel = value
        this.loading = true
        try {
            this.tableData = await new Report243Facade().rebuildReport(journalParams.params)
            this.journalParams = journalParams
            this.$emit('set-journal-params', cloneDeep(journalParams))
            this.tableKey += 1
        } catch (error) {
            console.error(error)
            if (this.filterSettingsForm && 'byBudgetLevel' in this.filterSettingsForm) {
                this.filterSettingsForm.byBudgetLevel = !value
            }
            makeToast(this, this.tr('toasts.' + 'error_generate_report'), this.tr('toasts.' + 'error'), 'danger')
        } finally {
            this.loading = false
        }
    }

    public onIsTreeInput() {
        this.resetIncomeInapplicableFlags()
        if (this.filterSettingsForm?.key === 'CASH-EXEC' || this.filterSettingsForm?.key === 'KF219-CO') {
            if (!this.filterSettingsForm.isTree) {
                this.filterSettingsForm.fillCbc = false
            }
        }
    }

    public onSvodTypeInput(type: any) {
        if (this.filterSettingsForm?.key === 'SVOD-PLAN' && this.filterOptions && 'periodicities' in this.filterOptions) {
            if (type.value === 'APPROVED') {
                this.filterSettingsForm.periodicity = cloneDeep(this.filterOptions.periodicities.find((it: any) => it.value === 'YEAR')!)
            } else {
                this.filterSettingsForm.periodicity = cloneDeep(this.filterOptions.periodicities.find((it: any) => it.value === 'DAY')!)
            }
            return
        }
    }


    private onBinInputGeneral(list: Option<string>[]) {
        if (list[list.length - 1].value === 'OTHER') {
            if (this.filterSettingsForm && 'oked' in this.filterSettingsForm) {
                this.filterSettingsForm.oked = cloneDeep(additionalSendersOptios.filter(it => it.value === 'OTHER'))
            }
            if (this.filterSettingsForm && 'kfs' in this.filterSettingsForm) {
                this.filterSettingsForm.kfs = cloneDeep(additionalSendersOptios.filter(it => it.value === 'OTHER'))
            }
            if (this.filterSettingsForm && 'kse' in this.filterSettingsForm) {
                this.filterSettingsForm.kse = cloneDeep(additionalSendersOptios.filter(it => it.value === 'OTHER'))
            }
            if (this.filterSettingsForm && 'krp' in this.filterSettingsForm) {
                this.filterSettingsForm.krp = cloneDeep(additionalSendersOptios.filter(it => it.value === 'OTHER'))
            }
            if (this.filterSettingsForm && 'senderbin' in this.filterSettingsForm) {
                this.filterSettingsForm.senderbin = []
            }
        } else if (list[list.length - 1].value === 'INDIVIDUAL') {
            if (this.filterSettingsForm && 'oked' in this.filterSettingsForm) {
                this.filterSettingsForm.oked = cloneDeep(additionalSendersOptios.filter(it => it.value === 'INDIVIDUAL'))
            }
            if (this.filterSettingsForm && 'kfs' in this.filterSettingsForm) {
                this.filterSettingsForm.kfs = cloneDeep(additionalSendersOptios.filter(it => it.value === 'INDIVIDUAL'))
            }
            if (this.filterSettingsForm && 'kse' in this.filterSettingsForm) {
                this.filterSettingsForm.kse = cloneDeep(additionalSendersOptios.filter(it => it.value === 'INDIVIDUAL'))
            }
            if (this.filterSettingsForm && 'krp' in this.filterSettingsForm) {
                this.filterSettingsForm.krp = cloneDeep(additionalSendersOptios.filter(it => it.value === 'INDIVIDUAL'))
            }
            if (this.filterSettingsForm && 'senderbin' in this.filterSettingsForm) {
                this.filterSettingsForm.senderbin = []
            }
        } else {
            if (this.filterSettingsForm && 'oked' in this.filterSettingsForm) {
                this.filterSettingsForm.oked = this.filterSettingsForm.oked.filter(it => !['OTHER', 'INDIVIDUAL'].includes(it.value))
            }
            if (this.filterSettingsForm && 'kfs' in this.filterSettingsForm) {
                this.filterSettingsForm.kfs = this.filterSettingsForm.kfs.filter(it => !['OTHER', 'INDIVIDUAL'].includes(it.value))
            }
            if (this.filterSettingsForm && 'kse' in this.filterSettingsForm) {
                this.filterSettingsForm.kse = this.filterSettingsForm.kse.filter(it => !['OTHER', 'INDIVIDUAL'].includes(it.value))
            }
            if (this.filterSettingsForm && 'krp' in this.filterSettingsForm) {
                this.filterSettingsForm.krp = this.filterSettingsForm.krp.filter(it => !['OTHER', 'INDIVIDUAL'].includes(it.value))
            }
        }
    }
    public async onBinInputMode(mode: string) {
        const methods: Record<string, Function> = {
            'oked': this.setOkedOptions,
            'kfs': this.setKfsOptions,
            'kse': this.setKseOptions,
            'krp': this.setKrpOptions,
            'senderbin': this.setSenderbinOptions
        }
        if (this.filterSettingsForm && this.filterSettingsForm.key === '2-43') {
            const keys: string[] = ['kfs', 'kse', 'krp', 'oked', 'senderbin']
            if (this.filterSettingsForm && mode in this.filterSettingsForm) {
                if (this.filterSettingsForm.oked.length && mode === 'oked') {
                    this.onBinInputGeneral(this.filterSettingsForm.oked);
                } else if (this.filterSettingsForm.kfs.length && mode === 'kfs') {
                    this.onBinInputGeneral(this.filterSettingsForm.kfs);
                } else if (this.filterSettingsForm.kse.length && mode === 'kse') {
                    this.onBinInputGeneral(this.filterSettingsForm.kse);
                } else if (this.filterSettingsForm.krp.length && mode === 'krp') {
                    this.onBinInputGeneral(this.filterSettingsForm.krp);
                }
                for (const key of keys.filter(it => it !== mode)) {
                    if (this.filterSettingsForm && key in this.filterSettingsForm) {
                        let k_arr: Option<string>[] = []
                        if (key === 'oked') {
                            k_arr = this.filterSettingsForm.oked
                        } else if (key === 'kfs') {
                            k_arr = this.filterSettingsForm.kfs
                        } else if (key === 'kse') {
                            k_arr = this.filterSettingsForm.kse
                        } else if (key === 'krp') {
                            k_arr = this.filterSettingsForm.krp
                        } else if (key === 'senderbin') {
                            k_arr = this.filterSettingsForm.senderbin
                        }

                        if (!k_arr.length) {
                            await methods[key]()
                        }
                    }
                }
            }
            if ('senderbin' in this.filterSettingsForm) {
                if (this.filterSettingsForm.senderbin.length > 0) {
                    this.filterSettingsForm.topN = false
                    this.filterSettingsForm.topNCount = null
                }
            }
        }
    }

    // Поскольу настройка порядка/исключения индикатора находится
    // в дочернем компоненте отрисовки таблиц, а не в самом filters-form,
    // при каждом изменений индикаторов в дочернем компоненте, надо обновлять параметры
    // выгрузки в журнал через этот метод
    public updateIndicators(newIndicators: Indicator[]) {
        if (!this.filterSettingsForm || !('indicators' in this.filterSettingsForm)) {
            return
        }
        this.filterSettingsForm.indicators = cloneDeep(newIndicators)

        if (this.journalParams == null) {
            return
        }
        if ('indicators_order' in this.journalParams) {
            // CASH-EXEC и т.п. — журнал хранит только порядок активных ключей
            const newOrder = newIndicators.filter(item => item.active).map(item => item.key)
            this.journalParams.indicators_order = newOrder
            this.$emit("set-journal-params", cloneDeep(this.journalParams))
        } else if ('indicators' in this.journalParams) {
            // DKI-R — журнал (DkiRExcelRequest) хранит полный список Indicator[], как в форме
            (this.journalParams as any).indicators = cloneDeep(newIndicators)
            this.$emit("set-journal-params", cloneDeep(this.journalParams))
        }
    }

    // Вызывается из report-br при изменении фильтра нулевых проектов (тоггл или видимые колонки).
    // Обновляет items в journalParams без перестройки всего отчёта.
    public updateBrExcelItems(items: unknown[]) {
        if (!this.journalParams || !('items' in this.journalParams)) return
        ;(this.journalParams as any).items = items
        this.$emit('set-journal-params', cloneDeep(this.journalParams))
    }

    // DKI-R: выбор месяцев блока "в том числе по месяцам" находится в дочернем компоненте
    // таблицы (выпадающий список над таблицей, RQ.eAk.RcDkiR.20) — по тому же принципу,
    // что и updateIndicators, синхронизируем его в форму и в параметры выгрузки в журнал.
    public updateMonths(newMonths: Indicator[]) {
        if (!this.filterSettingsForm || !('months' in this.filterSettingsForm)) {
            return
        }
        this.filterSettingsForm.months = cloneDeep(newMonths)

        if (this.journalParams == null || !('months' in this.journalParams)) {
            return
        }
        const activeMonths = newMonths.filter(item => item.active).map(item => Number(item.key))
        ;(this.journalParams as any).months = activeMonths
        this.$emit("set-journal-params", cloneDeep(this.journalParams))
    }

    private getKbkDate(): string {
        const fgk = this.filterSettingsForm as any
        const today = new Date()
        let d: Date | null = null

        // Порядок приоритета: date → periodTo → edate → конец месяца (year+month) → 31.12 года → сегодня
        for (const field of ['date', 'periodTo', 'edate']) {
            if (fgk?.[field]) {
                const parsed = new Date(fgk[field])
                if (!isNaN(parsed.getTime())) { d = parsed; break }
            }
        }

        if (!d && fgk?.year) {
            const year = Number(fgk.year)
            const monthVal = fgk?.month?.value
            if (monthVal != null && Number(monthVal) > 0) {
                // month 1-indexed → last day of that month
                d = new Date(year, Number(monthVal), 0)
            } else {
                d = new Date(year, 11, 31) // 31 декабря
            }
        }

        if (!d) d = today

        // Не позже сегодня
        if (d > today) d = today

        return moment(d).format('YYYY-MM-DD')
    }

    private async loadKbkOptions(): Promise<void> {
        if (!this.filterSettingsForm) return
        const seq = ++this.kbkLoadSeq

        const reportName = this.template.filterSettings.reportName
        let region = ''
        if (this.filterSettingsForm) {
            if ('region' in this.filterSettingsForm && this.filterSettingsForm.region?.value) {
                region = this.filterSettingsForm.region.value
            } else if ('regions' in this.filterSettingsForm && this.filterSettingsForm.regions && this.filterSettingsForm.regions.length > 0) {
                region = (this.filterSettingsForm.regions as any[]).map((r: any) => r.value).filter(Boolean).join(',')
            }
        }
        const userId = this.userId

        const kbkDate = this.getKbkDate()
        const flk = this.filterSettingsForm as any
        const bt: number[] = Array.isArray(flk?.budgetTypes)
            ? flk.budgetTypes.map((b: any) => b?.value).filter((v: any) => v != null)
            : (flk?.budgetType?.value != null ? [flk.budgetType.value] : [])
        const kbkBudgetTypes = bt.join(',')
        const dtVal2 = flk?.developType?.value
        const kbkDevelopType = dtVal2 != null ? String(dtVal2) : ''

        const kbkParams = new URLSearchParams({ report_name: reportName, region: region || '', user_id: userId || '' })
        if (kbkDate) kbkParams.set('date', kbkDate)
        if (kbkBudgetTypes) kbkParams.set('budget_types', kbkBudgetTypes)
        if (kbkDevelopType !== '') kbkParams.set('develop_type', kbkDevelopType)

        try {
            const resp = await fetch(`/api-py/monitoring/reports-constructor/kbk-options?${kbkParams}`)
            if (seq !== this.kbkLoadSeq) return
            if (!resp.ok) throw new Error(resp.statusText)
            const data = await resp.json() as KbkOptionsResponse
            if (seq !== this.kbkLoadSeq) return
            this.kbkOptions = data
        } catch {
            if (seq !== this.kbkLoadSeq) return
            makeToast(this, this.tr('toasts.error_fetch_kbk'), this.tr('toasts.error'), 'danger')
        }
    }

    @Watch('kbkQueryKey')
    private onKbkQueryKeyChange(newVal: string, oldVal: string) {
        if (newVal !== oldVal && this.filterSettingsForm) {
            this.loadKbkOptions()
        }
    }

    private async setTransfertOptions() {
        if (!this.filterSettingsForm || !("transferts" in this.filterSettingsForm)) {
            return
        }
        const strDate = moment(this.filterSettingsForm.date).format('YYYY-MM-DD')
        const transfertOptionsDataRequest = {
            "report_date": strDate,
            "region": this.filterSettingsForm.region?.value,
            "user_id": this.userId,
            "payment_type": (this.filterSettingsForm as any).paymentType?.value ?? 'PAYMENTS',
            "fundings": this.filterSettingsForm.transferts.find(it => it.key === "funding")?.selected.map(s => s.value) ?? [],
            "transfer_groups": this.filterSettingsForm.transferts.find(it => it.key === "transfer_group")?.selected.map(s => s.value) ?? [],
            "directions": this.filterSettingsForm.transferts.find(it => it.key === "direction")?.selected.map(s => s.value) ?? [],
            "gus": this.filterSettingsForm.transferts.find(it => it.key === "gu")?.selected.map(s => s.value) ?? [],
            "projects": this.filterSettingsForm.transferts.find(it => it.key === "project")?.selected.map(s => s.value) ?? [],
        }
        const transfertOptionsResponse = await fetch(`/api-py/monitoring/reports-constructor/transfert-options`,
            {
                method: 'POST',
                body: JSON.stringify(transfertOptionsDataRequest)
            }
        )
        if (!transfertOptionsResponse.ok) {
            makeToast(this, this.tr('toasts.' + 'error_fetch_transferts'), this.tr('toasts.' + 'error'), 'danger')
            return
        }

        const transfertOptionsData = await transfertOptionsResponse.json()

        for (const key in transfertOptionsData) {
            this.transfertOptions[key] = transfertOptionsData[key]
        }

        // Сбрасываем выбранные значения дочерних фильтров, которых больше нет в обновлённых опциях
        for (const transfert of this.filterSettingsForm.transferts) {
            if (transfert.key in this.transfertOptions) {
                const availableValues = new Set(this.transfertOptions[transfert.key].map((o: any) => o.value))
                transfert.selected = transfert.selected.filter((s: any) => availableValues.has(s.value))
            }
        }

    }

    private isCashExecGuSegmentationAllowed(form: FilterSettingsForm): boolean {
        if (form.key !== 'CASH-EXEC') {
            return false
        }
        return !(form.classificationType?.value === 'INCOMES' || (form.byForm?.value === '5-42' && form.dataSource?.value === 'LOADER'))
    }

    private setSegmentationsOptions() {
        if (this.filterSettingsForm?.key === 'CASH-EXEC' && this.filterOptions?.key === 'CASH-EXEC') {
            if (!this.isCashExecGuSegmentationAllowed(this.filterSettingsForm)) {
                this.filterSettingsForm.segmentations = cloneDeep(this.filterOptions.segmentations.filter(it => it.value !== 'GU'))
            } else {
                this.filterSettingsForm.segmentations = cloneDeep(this.filterOptions.segmentations)
            }
            return
        }
    }
    private async set243ReportOptions() {
        if (this.filterSettingsForm && 'senderbin' in this.filterSettingsForm) {
            await this.setSenderbinOptions()
        }
        if (this.filterSettingsForm && 'oked' in this.filterSettingsForm) {
            await this.setOkedOptions()
        }
        if (this.filterSettingsForm && 'kfs' in this.filterSettingsForm) {
            await this.setKfsOptions()
        }
        if (this.filterSettingsForm && 'kse' in this.filterSettingsForm) {
            await this.setKseOptions()
        }
        if (this.filterSettingsForm && 'krp' in this.filterSettingsForm) {
            await this.setKrpOptions()
        }
    }



    // Промежуточный метод для setRegionOptions
    // поскольку при созданий компонента год/квартал/месяц/дата берутся с props template
    private async setRegionOptionsOnCreate() {
        // Отчёты без периодичности, но с датой (OWN-INCOME, income_kbk)
        if (!('periodicity' in this.template.filterSettings)) {
            const key = this.template.filterSettings.reportName
            if (
                (key === 'OWN-INCOME' || key === 'income_kbk') &&
                'date' in this.template.filterSettings &&
                this.template.filterSettings.date
            ) {
                const date: string = this.template.filterSettings.date as string
                this.datePeriod = date
                await this.setRegionOptions()
            }
            return
        }
        const baseForm = this.facade!.getEmptyForm()

        const resetRegionAndDatePeriod = () => {
            this.datePeriod = null
            if (this.filterSettingsForm != null) {
                if ('regions' in this.filterSettingsForm) {
                    this.filterSettingsForm.regions = []
                } else if ('region' in this.filterSettingsForm) {
                    this.filterSettingsForm.region = null
                }
            }
        }
        if ('month' in this.template.filterSettings && 'periodicity' in this.template.filterSettings && this.template.filterSettings.periodicity === 'MONTH') {
            let year: number | null = null
            let month: number | null = null
            if (this.isNewForm && !this.isBatchExportTemplate) {
                year = (baseForm as any).year
                if (this.template.filterSettings.reportName === 'RECON-STATEMENT') {
                    month = ((baseForm as any).month as (Option<number>))?.value
                } else {
                    month = (baseForm as any).month
                }
            } else {
                year = this.template.filterSettings.year
                month = Number(this.template.filterSettings.month)
            }

            if (year && month) {
                this.datePeriod = getLastDateOfMonth(year, month)
                await this.setRegionOptions()
            } else {
                resetRegionAndDatePeriod()
            }
        }
        else if ('quarter' in this.template.filterSettings && 'periodicity' in this.template.filterSettings && this.template.filterSettings.periodicity === 'QUARTER') {
            let year: number | null = null
            let quarter: number | null = null
            if (this.isNewForm) {
                year = (baseForm as any).year
                quarter = (baseForm as any).quarter?.value
            } else {
                year = this.template.filterSettings.year
                quarter = Number(this.template.filterSettings.quarter)
            }

            if (year && quarter) {
                this.datePeriod = getLastDateOfQuarter(year, quarter)
                await this.setRegionOptions()
            } else {
                resetRegionAndDatePeriod()
            }
        }
        else if ('date' in this.template.filterSettings && 'periodicity' in this.template.filterSettings && this.template.filterSettings.periodicity === 'DAY') {
            let date: string | null = null

            if (this.isNewForm && (baseForm as any).date) {
                date = moment((baseForm as any).date).format('YYYY-MM-DD')
            } else {
                date = this.template.filterSettings.date
            }

            if (date) {
                this.datePeriod = date
                await this.setRegionOptions()
            } else {
                resetRegionAndDatePeriod()
            }
        }
        else if ('period' in this.template.filterSettings && 'periodicity' in this.template.filterSettings && this.template.filterSettings.periodicity === 'PERIOD') {
            if (!('periodTo' in baseForm)) {
                return
            }

            let date: string | null = null

            const periodTo = baseForm.periodTo
            if (this.isNewForm && periodTo) {
                date = moment(periodTo).format('YYYY-MM-DD')
            } else {
                date = this.template.filterSettings.period.to
            }

            if (date) {
                this.datePeriod = date
                await this.setRegionOptions()
            } else {
                resetRegionAndDatePeriod()
            }
        }
        else if ('year' in this.template.filterSettings && 'periodicity' in this.template.filterSettings && this.template.filterSettings.periodicity === 'YEAR') {
            let year: number | null = null
            if (this.isNewForm) {
                year = (baseForm as any).year
            } else {
                year = this.template.filterSettings.year
            }

            if (year) {
                this.datePeriod = `${year}-01-01`
                await this.setRegionOptions()
            } else {
                resetRegionAndDatePeriod()
            }
        }
        else if ('edate' in (this.template.filterSettings as any)) {
            let date: string | null = null
            if (this.isNewForm && (baseForm as any).edate) {
                date = moment((baseForm as any).edate).format('YYYY-MM-DD')
            } else if ((this.template.filterSettings as any).edate) {
                date = (this.template.filterSettings as any).edate
            }

            if (date) {
                this.datePeriod = date
                await this.setRegionOptions()
            } else {
                resetRegionAndDatePeriod()
            }
        }
    }

    private async setTemplateRegionOptions() {
        const response = await fetch(`/api-py/monitoring/reports-constructor/template-region-options/${this.oblastKato}`)
        if (!response.ok) {
            throw new Error('error_api_get_regions_failed')
        }

        const regionData = await response.json()

        const options: Option<string>[] = regionData.map((it: any) => {
            const obj: Option<string> = {
                value: '',
                label: ''
            }
            obj.value = it.code
            obj.label = it.code + ' - ' + it.name_ru
            obj.labelKk = it.code + ' - ' + it.name_kk

            return obj
        })
        options.unshift({ value: '000000', label: '000000 - Все', labelKk: '000000 - Барлығы', labelEn: '000000 - All' })

        this.templateFormOptions.regionOptions = options
    }

    private editStatusList() {
        if (this.filterSettingsForm?.key === 'INCOME' && this.filterOptions?.key === 'INCOME') {
            if ('statuses' in this.filterSettingsForm) {
                if (this.filterSettingsForm.statuses.length > 0) {
                    this.filterSettingsForm.statuses = this.filterSettingsForm.statuses.filter((x: any) => x.value !== '0')
                } else {
                    const allStatus: any = {
                        value: '0',
                        label: 'Все'
                    }
                    this.filterSettingsForm.statuses = [allStatus];
                }
            }
        }
        else if ((this.filterSettingsForm?.key === 'CASH-EXEC' && this.filterOptions?.key === 'CASH-EXEC') || (this.filterSettingsForm?.key === 'RECON-STATEMENT' && this.filterOptions?.key === 'RECON-STATEMENT') || (this.filterSettingsForm?.key === 'MBSP' && this.filterOptions?.key === 'MBSP')) {
            if ('statuses' in this.filterSettingsForm) {
                if (this.filterSettingsForm.statuses.length > 0) {
                    this.filterSettingsForm.statuses = this.filterSettingsForm.statuses.filter((x: any) => x.value !== '0')
                } else {
                    const allStatus: any = { value: '0', label: "Все", labelKk: "Барлығы", labelEn: "All" }
                    this.filterSettingsForm.statuses = [allStatus];
                }
            }
        }
        else if (this.filterSettingsForm?.key === 'RT' && this.filterOptions?.key === 'RT') {
            if ('statuses' in this.filterSettingsForm) {
                if (this.filterSettingsForm.statuses.length > 0) {
                    this.filterSettingsForm.statuses = this.filterSettingsForm.statuses.filter((x: any) => x.value !== '0')
                } else {
                    const allStatus: any = { value: '0', label: "Все", labelKk: "Барлығы", labelEn: "All" }
                    this.filterSettingsForm.statuses = [allStatus];
                }
            }
        }
        else if (this.filterSettingsForm?.key === 'income_kbk' && this.filterOptions?.key === 'income_kbk') {
            if ('statuses' in this.filterSettingsForm) {
                if (this.filterSettingsForm.statuses.length > 0) {
                    this.filterSettingsForm.statuses = this.filterSettingsForm.statuses.filter((x: any) => x.value !== '0')
                } else {
                    const allStatus: any = { value: '0', label: "Все", labelKk: "Барлығы", labelEn: "All" }
                    this.filterSettingsForm.statuses = [allStatus];
                }
            }
        }
        else if (this.filterSettingsForm?.key === 'OWN-INCOME' && this.filterOptions?.key === 'OWN-INCOME') {
            if ('statuses' in this.filterSettingsForm) {
                if (this.filterSettingsForm.statuses.length > 0) {
                    this.filterSettingsForm.statuses = this.filterSettingsForm.statuses.filter((x: any) => x.value !== '0')
                } else {
                    const allStatus: any = { value: '0', label: "Все", labelKk: "Барлығы", labelEn: "All" }
                    this.filterSettingsForm.statuses = [allStatus];
                }
            }
        }
        else if (this.filterSettingsForm?.key === 'SVOD-PLAN' && this.filterOptions?.key === 'SVOD-PLAN') {
            if ('statuses' in this.filterSettingsForm) {
                const currentVals = this.filterSettingsForm.statuses.map((x: any) => String(x.value))
                const hasAll = currentVals.includes('0')

                if (currentVals.length === 0) {
                    const allStatus: any = { value: '0', label: "Все", labelKk: "Барлығы", labelEn: "All" }
                    this.filterSettingsForm.statuses = [allStatus]
                    this.lastSvodStatuses = ['0']
                } else if (hasAll && this.lastSvodStatuses.indexOf('0') === -1) {
                    const allStatus: any = { value: '0', label: "Все", labelKk: "Барлығы", labelEn: "All" }
                    this.filterSettingsForm.statuses = [allStatus]
                    this.lastSvodStatuses = ['0']
                } else if (hasAll && this.lastSvodStatuses.indexOf('0') !== -1 && currentVals.length > 1) {
                    this.filterSettingsForm.statuses = this.filterSettingsForm.statuses.filter((x: any) => String(x.value) !== '0')
                    this.lastSvodStatuses = this.filterSettingsForm.statuses.map((x: any) => String(x.value))
                } else {
                    this.filterSettingsForm.statuses = this.filterSettingsForm.statuses.filter((x: any) => String(x.value) !== '0')
                    this.lastSvodStatuses = this.filterSettingsForm.statuses.map((x: any) => String(x.value))
                }
            }
        }
        else if (this.filterSettingsForm?.key === '1-27-DAILY' && this.filterOptions?.key === '1-27-DAILY') {
            if ('statuses' in this.filterSettingsForm) {
                if (this.filterSettingsForm.statuses.length > 0) {
                    this.filterSettingsForm.statuses = this.filterSettingsForm.statuses.filter((x: any) => x.value !== '0')
                } else {
                    const allStatus: any = {
                        value: '0',
                        label: 'Все'
                    }
                    this.filterSettingsForm.statuses = [allStatus];
                }
            }
        }
        else if (this.filterSettingsForm?.key === 'SVOD-DOH' && this.filterOptions?.key === 'SVOD-DOH') {
            if ('statuses' in this.filterSettingsForm) {
                const currentVals = this.filterSettingsForm.statuses.map((x: any) => String(x.value))
                const hasAll = currentVals.includes('0')

                if (currentVals.length === 0) {
                    const allStatus: any = { value: '0', label: "Все", labelKk: "Барлығы", labelEn: "All" }
                    this.filterSettingsForm.statuses = [allStatus]
                    this.lastSvodDohStatuses = ['0']
                } else if (hasAll && this.lastSvodDohStatuses.indexOf('0') === -1) {
                    const allStatus: any = { value: '0', label: "Все", labelKk: "Барлығы", labelEn: "All" }
                    this.filterSettingsForm.statuses = [allStatus]
                    this.lastSvodDohStatuses = ['0']
                } else if (hasAll && this.lastSvodDohStatuses.indexOf('0') !== -1 && currentVals.length > 1) {
                    this.filterSettingsForm.statuses = this.filterSettingsForm.statuses.filter((x: any) => String(x.value) !== '0')
                    this.lastSvodDohStatuses = this.filterSettingsForm.statuses.map((x: any) => String(x.value))
                } else {
                    this.filterSettingsForm.statuses = this.filterSettingsForm.statuses.filter((x: any) => String(x.value) !== '0')
                    this.lastSvodDohStatuses = this.filterSettingsForm.statuses.map((x: any) => String(x.value))
                }
            }
        }
    }

    private async setReportCategoryOptions() {
        const response = await fetch('/api-py/monitoring/reports-constructor/report-categories')
        if (!response.ok) {
            throw new Error('error_api_get_categories_failed')
        }
        const categoriesData = await response.json()

        const options: Option<string | null>[] = categoriesData.map((it: any) => ({
            value: it.code,
            label: it.name_ru,
            labelKk: it.name_kk,
            labelEn: it.name_en,
        }))
        options.push({ ...personalCategoryOption })

        this.templateFormOptions.reportCategoryOptions = options
    }

    get userAccessableReportCategoryOptions(): Option<string | null>[] {
        // Админу доступно все, другим доступно только в личных
        const accessibleOptions = this.templateFormOptions.reportCategoryOptions.filter(it => {
            if (this.isAdmin) {
                return true
            }
            const isOnlyPersonal = it.value === null
            return isOnlyPersonal
        })
        return accessibleOptions
    }

    private async setRegionOptions() {
        if (
            !this.datePeriod
            || this.filterOptions == null
            || !('regions' in this.filterOptions)
        ) {
            return
        }
        this.regionLoading = true
        try {
            let katoCode = this.$store.state._instanceCode
            if (!katoCode) {
                katoCode = 55
            }
            const response = await fetch(`/api-py/monitoring/reports-constructor/regions/${katoCode}/${this.userId}/${this.datePeriod}`)
            if (!response.ok) {
                throw new Error('error_load_regions_failed')
            }
            const data = await response.json()

            const regions: Option<string>[] = data.map((it: any) => {
                const obj: Option<string> = {
                    value: '',
                    label: ''
                }
                obj.value = it.code
                obj.label = it.code + ' - ' + it.name_ru
                obj.labelKk = it.code + ' - ' + it.name_kk

                return obj
            }).filter((it: Option<string>) => {
                if (this.template.filterSettings?.reportName === 'IRBO'){
                    if (it.value.length !== 6) return false;
                    if (isNaN(Number(it.value))) return false;

                    const lastFour = it.value.slice(2);
                    const lastTwo = it.value.slice(4);

                    return (
                        lastFour === "0000" ||
                        lastFour === "0101" ||
                        lastTwo === "00"
                    );
                } else if (this.template.filterSettings?.reportName === 'MBSP'){
                    if (it.value.length !== 6) return false;
                    if (isNaN(Number(it.value))) return false;
                    const lastFour = it.value.slice(2);
                    return lastFour !== "0100";
                } else {
                    return true
                }
            })

            this.filterOptions.regions = regions
            if (this.filterSettingsForm) {
                if ('region' in this.filterSettingsForm) {
                    const regionCode = this.filterSettingsForm.region?.value
                    const option: Option<string> | null = this.filterOptions.regions.find(it => it.value === regionCode) ?? null
                    this.filterSettingsForm.region = option
                }
                else if ('regions' in this.filterSettingsForm) {
                    const regionCodes = this.filterSettingsForm.regions.map(it => it.value)
                    const options = this.filterOptions.regions.filter(it => regionCodes.includes(it.value))
                    this.filterSettingsForm.regions = options
                }
            }
            // await this.checkUserLead();


        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_load_regions'), this.tr('toasts.' + 'error'), 'danger')
        } finally {
            this.regionLoading = false
        }
    }

    private async setCreditorOptions(budgetType: BudgetType | null, date: Date | null) {
        if (!this.filterOptions || !('creditors' in this.filterOptions)) {
            return
        }

        if (this.filterSettingsForm && 'creditor' in this.filterSettingsForm) {
            this.filterSettingsForm.creditor = null
        }

        this.filterOptions.creditors = await this.fetchCreditorOptions(budgetType, date)
    }
    private async fetchCreditorOptions(budgetLevel: number | null, date: Date | null): Promise<Option<string>[]> {
        const isRepublicanLevel = budgetLevel === 1

        if (budgetLevel == null) {
            return []
        } else if (!isRepublicanLevel && date == null) {
            return []
        }


        let url = ''
        if (isRepublicanLevel) {
            url = '/api/budget-loan/options/creditors/republican'
        } else {
            const formattedDate: string = moment(date).format('YYYY-MM-DD')
            if (formattedDate) {
                url = `/api/budget-loan/options/creditors/oblast?sign-date=${formattedDate}`
            } else {
                return []
            }
        }

        const response = await fetch(url)

        if (!response.ok) {
            makeToast(this, this.tr('toasts.' + 'error_load_creditors'), this.tr('toasts.' + 'error'), 'danger')
            return []
        }

        const responseData = await response.json()

        const creditorsOptions: Option<string>[] = responseData.map((it: any) => {
            let code: string = ''
            if (isRepublicanLevel) {
                code = String(it.abp)
            } else {
                code = it.code
            }

            const mapped: Option<string> = {
                value: code,
                label: `${code} - ${it.nameRu}`,
                labelKk: `${code} - ${it.nameKk}`,
                labelEn: `${code} - ${it.nameEn}`
            }

            return mapped
        })

        return creditorsOptions
    }

    private async setAdministratorOptions(userId: string) {
        if (!this.filterOptions || !('administrators' in this.filterOptions)) {
            return
        }

        if (this.filterSettingsForm && 'administrator' in this.filterSettingsForm) {
            this.filterSettingsForm.administrator = null
        }

        this.filterOptions.administrators = await this.fetchAdministratorOptions(userId)
    }
    private async fetchAdministratorOptions(userId: string): Promise<Option<string>[]> {
        const response = await fetch(`/api/dict/gu/administrator/filter/${userId}`)
        if (!response.ok) {
            makeToast(this, this.tr('toasts.' + 'error_load_administrators'), this.tr('toasts.' + 'error'), 'danger')
            return []
        }

        const data = await response.json()
        const options: Option<string>[] = data.map((it: any) => {
            const option: Option<string> = {
                value: it.code,
                label: `${it.code} - ${it.nameRu}`,
                labelKk: `${it.code} - ${it.nameKk}`,
                labelEn: `${it.code} - ${it.nameEn}`
            }
            return option
        })

        return options
    }

    private async setContractorOptions(userId: string) {
        if (!this.filterOptions || !('contractors' in this.filterOptions)) {
            return
        }

        if (this.filterSettingsForm && 'contractor' in this.filterSettingsForm) {
            this.filterSettingsForm.contractor = null
        }

        this.filterOptions.contractors = await this.fetchContractorOptions(userId)
    }
    private async fetchContractorOptions(userId: string): Promise<Option<string>[]> {
        const response = await fetch(`/api/dict/gu/contractor/filter/${userId}`)
        if (!response.ok) {
            makeToast(this, this.tr('toasts.' + 'error_load_contractors'), this.tr('toasts.' + 'error'), 'danger')
            return []
        }

        const data = await response.json()
        const options: Option<string>[] = data.map((it: any) => {
            const option: Option<string> = {
                value: it.code,
                label: `${it.code} - ${it.nameRu}`,
                labelKk: `${it.code} - ${it.nameKk}`,
                labelEn: `${it.code} - ${it.nameEn}`
            }
            return option
        })

        return options
    }

    private async setLoanPurposeOptions(date: string) {
        if (!this.filterOptions || !('loanPurposes' in this.filterOptions)) {
            return
        }

        if (this.filterSettingsForm && 'loanPurpose' in this.filterSettingsForm) {
            this.filterSettingsForm.loanPurpose = null
        }

        this.filterOptions.loanPurposes = await this.fetchLoanPurposeOptions(date)
    }
    private async fetchLoanPurposeOptions(date: string): Promise<Option<string>[]> {
        const response = await fetch(`/api/dict/bc_goal/active-by-date?date=${date}`)
        if (!response.ok) {
            makeToast(this, this.tr('toasts.' + 'error_load_loan_purposes'), this.tr('toasts.' + 'error'), 'danger')
            return []
        }

        const data = await response.json()
        const options: Option<string>[] = data.map((it: any) => {
            const option: Option<string> = {
                value: it.code,
                label: `${it.code} - ${it.nameRu}`,
                labelKk: `${it.code} - ${it.nameKk}`,
                labelEn: `${it.code} - ${it.nameRu}`
            }
            return option
        })

        return options
    }

    private async setFilterOptions() {
        const options = this.facade!.getFilterOptions()

        if (!this.isIncomesAvailable) {
            options.classificationTypes = options.classificationTypes.filter(it => it.value !== 'INCOMES')
        }
        if (!this.isExpensesAvailable) {
            options.classificationTypes = options.classificationTypes.filter(it => it.value !== 'EXPENSES')
        }

        if (options.key === 'RS' && 'certificateLevels' in options) {
            const isUoUser = this.userAccessLevels['is_oblast_uo']
                || this.userAccessLevels['is_raion_uo']
                || this.userAccessLevels['is_msu_uo']
                || this.userAccessLevels['is_techsupport_or_consultant']
            if (!isUoUser) {
                (options as any).certificateLevels = (options as any).certificateLevels.filter((it: any) => it.value !== 'UO')
            }
        }

        if (options.key === 'SVOD-PLAN' && 'planTypes' in options) {
            if (!this.isIncomesAvailable) {
                options.planTypes = options.planTypes.filter(it => it.value !== 'PP')
            }
            if (!this.isExpensesAvailable) {
                options.planTypes = options.planTypes.filter(it => it.value !== 'PF')
            }

            const templateSettings = this.template.filterSettings
            if ('region' in templateSettings && 'year' in templateSettings
                && templateSettings.reportName === 'SVOD-PLAN'
            ) {
                const region: string | null = templateSettings.region
                const year: number | null = templateSettings.year
                const expenses: Classificator[] = cloneDeep(templateSettings.expenses)
                if (region && year) {
                    await this.getUserGu(region, year, expenses)
                }
                options.gu = this.userGu
                options.gu261 = this.userGu261
            }
        }

        if (options.key === 'LOAN-STATUS' && this.template.filterSettings.reportName === 'LOAN-STATUS') {
            options.administrators = await this.fetchAdministratorOptions(this.userId)
            options.contractors = await this.fetchContractorOptions(this.userId)

            const date = this.template.filterSettings.date
            if (date) {
                options.loanPurposes = await this.fetchLoanPurposeOptions(date)
            }
        }

        this.filterOptions = options
    }

    private async setFilterSettingsForm() {
        if (this.filterOptions == null) {
            throw new Error('error_filter_data_missing')
        }

        let form: FilterSettingsForm | null = null
        if (this.isNewForm && !this.isBatchExportTemplate) {
            form = this.facade!.getEmptyForm()
        } else {
            form = this.facade!.settingsToForm(
                cloneDeep(this.template.filterSettings),
                cloneDeep(this.filterOptions)
            )
        }

        if (form.classificationType.value === 'INCOMES' && !this.isIncomesAvailable) {
            form.classificationType = allClassificationTypesOptions.find(it => it.value === 'EXPENSES')!
        }
        else if (form.classificationType.value === 'EXPENSES' && !this.isExpensesAvailable) {
            form.classificationType = allClassificationTypesOptions.find(it => it.value === 'INCOMES')!
        }


        if (form.key === 'SVOD-PLAN' && 'planType' in form) {
            if (!this.isIncomesAvailable) {
                form.planType = allPlanOptions.find(it => it.value === 'PF')!
            }
            if (!this.isExpensesAvailable) {
                form.planType = allPlanOptions.find(it => it.value === 'PP')!
            }
            // Нормализация ABP: при загрузке шаблона selected может прийти числом (не массивом)
            if ('expenses' in form) {
                const abpItem = (form as any).expenses.find((it: any) => it.key === 'abp')
                if (abpItem && !Array.isArray(abpItem.selected)) {
                    abpItem.selected = abpItem.selected != null ? [abpItem.selected] : []
                }
            }
        }
        if (form.key === 'CASH-EXEC' && !this.isIncomesAvailable && 'byForms' in this.filterOptions) {
            form.byForm = this.filterOptions.byForms.find((it:Option<ByForm>) => it.value === '4-20')!
            if (form.classificationType?.value === 'INCOMES') {
                form.indicators = cloneDeep(reportCashExecIncomeIndicators)
            } else if (form.classificationType?.value === 'EXPENSES') {
                form.indicators = cloneDeep(reportCashExecExpenseIndicators)
            }
        }
        if (form.key === 'CASH-EXEC' && this.filterOptions.key === 'CASH-EXEC' && this.isCashExecGuSegmentationAllowed(form)) {
            const segmentations = form.segmentations ?? []
            const guOption = this.filterOptions.segmentations.find(it => it.value === 'GU')
            if (guOption && !segmentations.some(it => it.value === 'GU')) {
                form.segmentations = [...segmentations, { ...cloneDeep(guOption), active: false }]
            }
        }

        console.log(form)
        this.filterSettingsForm = cloneDeep(form)
        if (this.template.filterSettings.reportName === '2-43' && !this.isNewForm) {
            this.set243ReportOptions()
        }

        if (this.isNewForm && !this.isBatchExportTemplate) {
            this.setAsyncDefaults(this.filterSettingsForm, this.filterOptions)
        }

        // Для 1-27 пакеток
        if (this.isNewForm && this.isBatchExportTemplate && this.filterSettingsForm.key === '1-27' && this.filterOptions.key === '1-27') {
            if (this.filterOptions.regions.length > 0) {
                // Задать регион первым в списке и ур. бюджета
                const regionOption = cloneDeep(this.filterOptions.regions[0])
                this.filterSettingsForm.regions = [regionOption]
                // Задать ур. бюджета
                this.onRegionInput(regionOption)
                // Задать ВЗК
                const ifEndsWith00 = regionOption.value.endsWith('00')
                if (ifEndsWith00) {
                    const withoutMutuallyRedeemingOption = cloneDeep(
                        this.filterOptions.mutuallyRedeeming.find(it => it.value === 'WITHOUT')
                    )!
                    this.filterSettingsForm.mutuallyRedeeming = withoutMutuallyRedeemingOption
                } else {
                    const withMutuallyRedeemingOption = cloneDeep(
                        this.filterOptions.mutuallyRedeeming.find(it => it.value === 'WITH')
                    )!
                    this.filterSettingsForm.mutuallyRedeeming = withMutuallyRedeemingOption
                }
            }
        }

        // filterSettingsForm уже создан — запускаем загрузку КБК
        this.loadKbkOptions()
        // Применяем каскад чек-боксов при открытии шаблона
        if (!this.isNewForm) {
            this.applyClassificationCascade()
        }
    }

    // Задает дефолтные значения для пустых полей, варианты которых подгружаются асинхронно
    // Для остальных полей дефолт задается в метода фасада .getEmptyForm()
    private setAsyncDefaults(form: FilterSettingsForm, options: FilterOptions) {
        if (form.key === 'EIB' && options.key === 'EIB') {
            const regionOption = options.regions[0] ?? null
            if (regionOption) {
                form.region = regionOption
                this.onRegionInput(regionOption)
            }
        }
        // DKI-R: регион по умолчанию — первый доступный в списке (RQ.eAk.RcDkiR.23)
        if (form.key === 'DKI-R' && options.key === 'DKI-R') {
            const regionOption = options.regions[0] ?? null
            if (regionOption) {
                form.region = regionOption
                this.onRegionInput(regionOption)
            }
        }
        // SVOD-MB: регион по умолчанию — первый в списке (§1.2 постановки)
        if (form.key === 'SVOD-MB' && options.key === 'SVOD-MB') {
            const regionOption = options.regions[0] ?? null
            if (regionOption) {
                form.region = regionOption
                this.onRegionInput(regionOption)
            }
        }
        if (form.key === 'OWN-INCOME' && 'date' in form && (form as any).date) {
            this.onDateChange()
        }
    }

    private setTemplateForm() {
        if (!this.template.id) {
            return
        }

        const allRegionCode = '000000'

        let tempRegions: Option<string>[] | Option<string> | null = null
        if (this.template.regions.includes(allRegionCode)) {
            const allRegionOption = this.templateFormOptions.regionOptions.find(it => it.value = allRegionCode)!
            tempRegions = allRegionOption
        }
        else {
            const selectedOptions = this.templateFormOptions.regionOptions.filter(it => this.template.regions.includes(it.value))
            tempRegions = selectedOptions
        }

        const category = this.templateFormOptions.reportCategoryOptions.find(it => it.value === this.template.category)
        if (category == undefined) {
            throw new Error('error_val_no_category')
        }

        const form: TemplateForm = {
            id: this.template.id,
            name: this.template.name,
            excelName: this.template.excelName ?? '',
            description: this.template.description,
            category: category,
            regions: tempRegions,
        }

        this.templateForm = form
    }

    async onConstructReport() {
        this.loading = true
        try {
            await this.constructReport()
        } catch (error) {
            if (error instanceof Error) {
                console.error(error.message)
                makeToast(this, this.tr('toasts.' + error.message), this.tr('toasts.' + 'error'), 'danger')
            } else {
                console.error(error)
                makeToast(this, this.tr('toasts.' + 'error_generate_report'), this.tr('toasts.' + 'error'), 'danger')
            }
        } finally {
            this.loading = false
        }
    }

    async constructReport() {
        if (this.filterSettingsForm == null) {
            throw new Error('error_report_form_missing')
        }
        let templateName: string = this.template.name // Base name
        let excelName: string | null = this.template.excelName // TODO: consider updating 'template' property to update after onSave()
        const hasOwnTemplateName = Boolean(this.templateForm.id)
        if (hasOwnTemplateName) {
            templateName = this.templateForm.name
            excelName = this.templateForm.excelName ?? ''
        }


        const formToConstructReport = cloneDeep(this.filterSettingsForm);

        // T5: проверка ДО автозаполнения selected через setIncomeExpenseToPassAndUserAvailableKbks
        if ('incomes' in formToConstructReport) {
            validateClassificatorsBlock((formToConstructReport as any).incomes)
        }
        if ('expenses' in formToConstructReport) {
            validateClassificatorsBlock((formToConstructReport as any).expenses)
        }

        this.setIncomeExpenseToPassAndUserAvailableKbks(formToConstructReport)

        if ('transferts' in formToConstructReport) {
            this.transfertsToPass = cloneDeep(formToConstructReport.transferts)
        }

        if (!this.isIncomesAvailable && 'incomes' in formToConstructReport) {
            formToConstructReport.incomes = []
        }
        if (!this.isExpensesAvailable && 'expenses' in formToConstructReport) {
            formToConstructReport.expenses = []
        }
        try {
            await this.clearPaginationCache()
        } catch (e) {

        }

        const { tableData, journalParams, cashDateWarning } = await this.facade!.constructReport(
            formToConstructReport,
            templateName,
            excelName,
            this.userId,
        )
        this.tableData = tableData
        this.tableGeneratedDate = 'date' in formToConstructReport ? (formToConstructReport as any).date : null
        this.cashDateWarning = cashDateWarning ?? null
        if (formToConstructReport.key === 'KSN') {
            this.ksnRoundUp = 'roundUp' in formToConstructReport ? (formToConstructReport as any).roundUp : false
            this.ksnRoundUpTo = 'roundUpTo' in formToConstructReport ? (formToConstructReport as any).roundUpTo : null
        }
        if ('segmentations' in formToConstructReport && Array.isArray((formToConstructReport as any).segmentations)) {
            this.tableSegmentations = cloneDeep((formToConstructReport as any).segmentations)
        }
        if ('expenses' in formToConstructReport && Array.isArray((formToConstructReport as any).expenses)) {
            this.tableExpenses = cloneDeep((formToConstructReport as any).expenses).map((e: any) => ({ key: e.key, active: e.active }))
        }
        this.journalParams = cloneDeep(journalParams)
        this.$emit("set-journal-params", cloneDeep(journalParams))

        if (journalParams.reportName === 'RS' && journalParams.params) {
            this.setBatchExportParams(journalParams.params)
        }

        // Мануально затригерить re-render таблицы
        this.tableKey += 1

        makeToast(this, this.tr('toasts.' + 'generated'), this.tr('toasts.' + 'message_title'), 'success')

    }
    private async clearPaginationCache() {
        await fetch('/api-py/monitoring/reports-constructor/cache/clean', {
            method: 'DELETE'
        })
    }

    private setIncomeExpenseToPassAndUserAvailableKbks(form: FilterSettingsForm) {
        if ('incomes' in form) {
            this.incomesToPass = cloneDeep(form.incomes) // Side effect
            const incomeExclusions = ['CASH-EXEC', 'RECON-STATEMENT', 'MBSP', '2-43', 'KF219-CO']
            if (!incomeExclusions.includes(form?.key)) {
                for (const income of form.incomes) {
                    if (income.selected.length === 0 && ['kat'].includes(income.key)) {
                        // Берём коды уровня из kbk-options (cascadeOptions = совместимые коды)
                        const levelOpts = this.cachedIncomeOptions[income.key]
                        income.selected = levelOpts
                            ? levelOpts.cascadeOptions.map(o => o.code)
                            : []
                    }
                }
            }
        }
        if ('expenses' in form) {
            this.expensesToPass = cloneDeep(form.expenses) // Side effect
            const expenseExclusions = ['CASH-EXEC', 'IPIPM', 'RECON-STATEMENT', 'MBSP', 'SVOD-RAS']
            if (!expenseExclusions.includes(form?.key)) {
                for (const expense of form.expenses) {
                    if (expense.selected.length === 0 && ['gr', 'gu', 'abp'].includes(expense.key)) {
                        // Берём коды уровня из kbk-options (cascadeOptions = совместимые коды)
                        const levelOpts = this.cachedExpenseOptions[expense.key]
                        expense.selected = levelOpts
                            ? levelOpts.cascadeOptions.map(o => o.code)
                            : []
                    }
                }
            }
        }
    }

    public async settingsToDefault() {
        this.tableData = null
        this.tableGeneratedDate = null
        this.cashDateWarning = null
        this.tableSegmentations = []
        this.tableExpenses = []
        this.setFilterSettingsForm()
        // Значение «Агрегации по МСУ» из шаблона. После сброса регион пуст или подставляется заново,
        // переключатель скрывается, и watcher showMsuAggregation сбрасывает его в false — тогда при
        // выборе региона он появился бы выключенным.
        const msuAggregationDefault: boolean | null = this.filterSettingsForm && 'msuAggregation' in this.filterSettingsForm
            ? (this.filterSettingsForm as any).msuAggregation
            : null
        if (this.filterSettingsForm && 'byBudgetLevel' in this.filterSettingsForm) {
            this.filterSettingsForm.byBudgetLevel = false
        }
        await this.setRegionOptionsOnCreate()
        await this.$nextTick() // дождаться срабатывания watcher showMsuAggregation
        if (msuAggregationDefault !== null && this.filterSettingsForm && 'msuAggregation' in this.filterSettingsForm) {
            // KF219-CO: регион после сброса пуст, переключатель скрыт — значение шаблона возвращаем и так;
            // в запрос агрегация уходит, только если она применима (Kf219CoFacade). У остальных отчётов
            // (1-27 не проверяет регион на бэке) — только если переключатель виден.
            if (this.filterSettingsForm.key === 'KF219-CO' || this.showMsuAggregation) {
                (this.filterSettingsForm as any).msuAggregation = msuAggregationDefault
            }
        }
    }

    public toggleSaveModal(value: boolean | null = null) {
        if (typeof value === 'boolean') {
            this.saveModal = value
        } else {
            this.saveModal = !this.saveModal
        }
    }

    public async onSave() {
        if (this.filterSettingsForm == null) {
            return
        }

        if (!this.templateForm.name) {
            makeToast(this, this.tr('toasts.' + 'name_required'), this.tr('toasts.' + 'message_title'), 'danger')
            return
        }

        const baseTemplateNames = allReportNamesOptions.map(it => it.value.toLowerCase())
        if (baseTemplateNames.includes(this.templateForm.name.toLowerCase())) {
            makeToast(this, this.tr('toasts.' + 'name_change_required'), this.tr('toasts.' + 'message_title'), 'danger')
            return
        }

        let settings: FilterSettings | null = null
        try {
            settings = this.facade!.formToSettings(cloneDeep(this.filterSettingsForm))
        } catch (error) {
            if (error instanceof Error) {
                console.error(error.message)
                makeToast(this, this.tr('toasts.' + error.message), this.tr('toasts.' + 'error'), 'danger')
            } else {
                console.error(error)
                makeToast(this, this.tr('toasts.' + 'error_template_conversion'), this.tr('toasts.' + 'error'), 'danger')
            }
            return
        }

        // TODO: region templateForm
        const requestBody = await this.convertTemplateFormToRequestBody(
            cloneDeep(this.templateForm),
            cloneDeep(settings),
            this.userId,
            this.oblastKato
        )
        const response = await fetch('/api-py/monitoring/reports-constructor/templates', {
                method: 'PUT',
                body: JSON.stringify(requestBody)
            }
        )
        if (!response.ok) {
            makeToast(this, this.tr('toasts.' + 'error_save_template'), this.tr('toasts.' + 'error'), 'danger')
            return
        }
        const addedItem = await response.json()
        this.templateForm.id = addedItem.id
        this.toggleSaveModal(false)
        this.templateName = this.templateForm.name

        this.tableData = null
        this.tableGeneratedDate = null
        this.cashDateWarning = null
        this.journalParams = null
        this.$emit("set-journal-params", null)

        if (requestBody.id == null) {
            makeToast(this, this.tr('toasts.' + 'saved'), this.tr('toasts.' + 'message_title'), 'success')
        } else {
            makeToast(this, this.tr('toasts.' + 'changes_saved'), this.tr('toasts.' + 'message_title'), 'success')
        }
    }

    private async convertTemplateFormToRequestBody(
        form: TemplateForm,
        filterSettings: FilterSettings,
        userId: string,
        oblastKato: string
    ): Promise<TemplateCreateUpdateRequest> {
        let categoryCode: string | null = null
        if (form.category && form.category.value) {
            categoryCode = String(form.category.value)
        }

        let regions: string[] = []
        if (categoryCode != null) {
            if (form.regions === null) {
                throw new Error('error_val_region_required')
            } else if (Array.isArray(form.regions)) {
                regions = form.regions.map(it => String(it.value))
            } else {
                regions = [String(form.regions.value)]
            }
        } else {
            let tempRegion = '000000'

            const isTestOrNsi = oblastKato === '00' || oblastKato === '99'
            if (!isTestOrNsi) {
                tempRegion = this.oblastCode + '0101'
            }

            regions = [tempRegion]
        }

        const requestBody: TemplateCreateUpdateRequest = {
            id: form.id,
            name: form.name,
            excel_name: form.excelName,
            description: form.description,
            category: categoryCode,
            regions: regions,
            filter_settings: filterSettings,
            user_id: userId,
            oblast_kato: oblastKato
        }

        return requestBody
    }

    public isClassificatorCheckboxDisabled(classificatorKey: string): boolean {
        // Для 1-27-DAILY: если разрезность "Регион", КБК чекбоксы неактивны
        if (this.isDailyRegionActive) {
            return true
        }
        // DKI-R: нельзя отключить последний активный разрез расходов (RQ.eAk.RcDkiR.12)
        if (
            this.template.filterSettings.reportName === 'DKI-R'
            && this.filterSettingsForm
            && 'expenses' in this.filterSettingsForm
        ) {
            const activeCount = this.filterSettingsForm.expenses.filter(it => it.active).length
            const isCurrentActive = this.filterSettingsForm.expenses.find(it => it.key === classificatorKey)?.active
            if (activeCount <= 1 && isCurrentActive) {
                return true
            }
        }
        if (classificatorKey === 'abp' && (kbkBehaviorConfig[this.template.filterSettings.reportName]?.abpCheckboxDisabled ?? false)) {
            return true
        }
        return false
    }

    public isClassificatorCheckboxHidden(): boolean {
        return kbkBehaviorConfig[this.template.filterSettings.reportName]?.checkboxHidden ?? false
    }
    public isClassificatorIncomeCheckboxHidden(): boolean {
        return kbkBehaviorConfig[this.template.filterSettings.reportName]?.incomeCheckboxHidden ?? false
    }

    public isClassificatorMultiselectDisabled(classificatorKey: string): boolean {
        if (classificatorKey === 'spf') {
            return kbkBehaviorConfig[this.template.filterSettings.reportName]?.spfMultiselectDisabled ?? false
        }
        return false
    }

    public isClassificatorDraggingDisabled(): boolean {
        return kbkBehaviorConfig[this.template.filterSettings.reportName]?.draggingDisabled ?? false
    }
    public isClassificatorIncomeDraggingDisabled(): boolean {
        return kbkBehaviorConfig[this.template.filterSettings.reportName]?.incomeDraggingDisabled ?? false
    }

    public get topNdisabled() {
        if (this.filterSettingsForm?.key === '2-43') {
            return this.filterSettingsForm.senderbin.length > 0 || this.filterSettingsForm.segmentations?.filter(it => it.value === 'SENDERBIN' && it.active).length === 0
        }
        return false
    }

    private async checkUserLead() {
        if (this.userId && this.datePeriod && this.template.filterSettings.reportName === 'SVOD-PLAN') {
            const response = await fetch(`/api-py/monitoring/reports-constructor/user-lead/${this.userId}`);
            if (!response.ok) {
                throw new Error('error_load_pf_type_failed')
            }
            const isLead = await response.text()
            if (isLead === 'true') {
                this.isUserLead = true;
            }

            // commented due to adding userAccessLevels prop
            // if (this.filterOptions != null && 'typePFs' in this.filterOptions) {
            //     const responsePF = await fetch(`/api-py/monitoring/reports-constructor/user-pf/${this.userId}`);
            //     if (!responsePF.ok) {
            //         throw new Error('error_load_pf_type_failed')
            //     }
            //     const isPF = await responsePF.text();
            //     if (isPF === 'false') {
            //         this.filterOptions.typePFs = this.filterOptions.typePFs.filter(item => item.value !== 'PF');
            //     }
            //     // if (isLead === 'false') {
            //     //     this.filterOptions.typePFs = this.filterOptions.typePFs.filter(item => item.value !== 'SPF');
            //     // }
            // }
        }
    }


    private setUserTypePfOptions() {
        if (this.userId && this.datePeriod && this.template.filterSettings.reportName === 'SVOD-PLAN') {
            if (this.filterOptions != null && 'typePFs' in this.filterOptions) {
                if (
                    this.userAccessLevels['is_techsupport_or_consultant']
                    || this.userAccessLevels['is_oblast_uo']
                    || this.userAccessLevels['is_raion_uo']
                    || this.userAccessLevels['is_msu_uo']
                ) {
                    this.filterOptions.typePFs = this.filterOptions.typePFs;
                } else if (
                    this.userAccessLevels['is_abp']
                    || this.userAccessLevels['is_education_department']
                ) {
                    this.filterOptions.typePFs = this.filterOptions.typePFs.filter(item => item.value !== 'SPF');
                } else if (this.userAccessLevels['is_gu']) {
                    this.filterOptions.typePFs = this.filterOptions.typePFs.filter(item => item.value !== 'SPF' && item.value !== 'PF');
                } else {
                    this.filterOptions.typePFs = []
                }
            }
        }
    }

    private async getUserGu(
        region: string | null,
        dateOrYear: Date | number | null,
        expenses: Classificator[]
    ) {
        const abpFromForm = expenses.find((e: any) => e.key === 'abp')

        if (!abpFromForm) {
            this.userGu = []
            return;
        }

        const selected: number[] = Array.isArray(abpFromForm.selected)
            ? abpFromForm.selected
            : abpFromForm.selected != null
            ? [abpFromForm.selected]
            : [];

        if (!region || !dateOrYear) {
            this.userGu = []
            return;
        }

        if (this.filterSettingsForm && 'gu' in this.filterSettingsForm) {
            if (Array.isArray(this.filterSettingsForm.gu)) {
                this.filterSettingsForm.gu = [];
            } else {
                this.filterSettingsForm.gu = null;
            }
        }

        try {
            let strDate: string | null = null
            if (dateOrYear instanceof Date) {
                strDate = moment(dateOrYear).format('YYYY-MM-DD')
            } else {
                strDate = `${dateOrYear}-01-01`
            }

            // Если ни одного ABP не выбрано — запрашиваем все (abp='0')
            // Если выбраны один или несколько ABP — делаем запрос для каждого и объединяем результаты
            const abpCodes: string[] = selected.length === 0
                ? ['0']
                : selected.map((code: number) => String(code).padStart(3, '0'))

            const responses = await Promise.all(
                abpCodes.map(abpCode =>
                    fetch(`/api-py/monitoring/reports-constructor/user-gu-access/${this.userId}/${strDate}/${abpCode}/${region}`)
                )
            )
            for (const response of responses) {
                if (!response.ok) {
                    throw new Error('error_load_gu_failed');
                }
            }
            const allData: any[][] = await Promise.all(responses.map(r => r.json()))
            // Объединяем, дедуплицируем по code
            const seenCodes = new Set<string>()
            const options: Option<string>[] = []
            for (const data of allData) {
                for (const it of data) {
                    if (!seenCodes.has(it.code)) {
                        seenCodes.add(it.code)
                        options.push({
                            value: it.code,
                            label: it.code + ' - ' + it.name_ru,
                            labelKk: it.code + ' - ' + it.name_kk,
                            labelEn: it.code + ' - ' + it.name_en,
                        })
                    }
                }
            }

            this.userGu = options;

            await this.getUser261Gu(region, dateOrYear);
        } catch (error) {
            if (error instanceof Error) {
                makeToast(this, this.tr('toasts.' + error.message), this.tr('toasts.' + 'error'), 'danger')
                console.error(error.message)
            } else {
                makeToast(this, this.tr('toasts.' + 'error'), this.tr('toasts.' + 'error'), 'danger')
                console.error(error);
            }
            console.error('Ошибка при получении данных о ГУ:', error);
        }
    }

    private async getUser261Gu(region: string | null, dateOrYear: Date | number | null) {
        if (!region || !dateOrYear) {
            this.userGu261 = []
            return;
        }

        let strDate: string | null = null
        if (dateOrYear instanceof Date) {
            strDate = moment(dateOrYear).format('YYYY-MM-DD')
        } else {
            strDate = `${dateOrYear}-01-01`
        }

        const response = await fetch(`/api-py/monitoring/reports-constructor/user-gu-261/${strDate}/${this.userId}/${region}`);
        if (!response.ok) {
            throw new Error('error_load_gu_261_failed')
        }
        const data = await response.json()

        this.userGu261 = data.map((it: any) => {
            const obj: Option<string> = {
                value: '',
                label: ''
            }

            obj.value = it.code
            obj.label = it.code + ' - ' + it.name_ru
            obj.labelKk = it.code + ' - ' + it.name_kk
            obj.labelEn = it.code + ' - ' + it.name_en

            return obj
        })
    }

    private async getStatusList() {
        if (!this.datePeriod) return
        const response = await fetch(`/api-py/monitoring/reports-constructor/status-list/${this.datePeriod}`);
        if (!response.ok) {
            throw new Error('Ошибка загрузки данных о списке статусов')
        }
        const data = await response.json()

        this.svodPlanStatusList = data.map((it: any) => ({
            value: String(it.code),
            label: it.code + ' - ' + it.name_ru,
            labelKk: it.code + ' - ' + it.name_kk,
            labelEn: it.code + ' - ' + it.name_ru
        }))
    }

    public getSvodPlanAbpMaxItems(item: any): number {
        if (
            this.filterSettingsForm?.key === 'SVOD-PLAN' &&
            item.key === 'abp' &&
            this.filterSettingsForm.typePF?.value !== 'SPF'
        ) {
            return 1
        }
        return 0
    }

    private onPFInput(): void {

        if (this.filterSettingsForm && 'gu' in this.filterSettingsForm) {
            this.filterSettingsForm.gu = null
        }

        if (
            this.filterSettingsForm != null &&
            this.filterSettingsForm.key === 'SVOD-PLAN' &&
            this.filterSettingsForm.typePF?.value !== 'SPF'
        ) {
            const abp: any = this.filterSettingsForm.expenses.find((item: any) => item.key === 'abp');

            if (abp) {
                // Нормализуем selected к массиву (на случай если пришло числом из шаблона)
                const currentSelected: number[] = Array.isArray(abp.selected)
                    ? abp.selected
                    : abp.selected != null ? [abp.selected] : []
                // При ИПФ/ПФ — оставляем только первый ABP в виде массива
                abp.selected = currentSelected.length ? [currentSelected[0]] : []
            }
        }
    }

    public getTransfertSelectionWarningText(key: string): string {
        if (!this.filterSettingsForm || !("transferts" in this.filterSettingsForm)) {
            return ""
        }
        switch (key) {
            case 'funding': {
                if (this.filterSettingsForm.region == null || this.filterSettingsForm.date == null) {
                    return 'error_fill_region_date'
                }
                return 'error_no_funding_by_params'
            }
            case 'gu': {
                if (this.filterSettingsForm.region == null || this.filterSettingsForm.date == null) {
                    return 'error_fill_region_date'
                }
                return 'error_no_gu_by_params'
            }
            case 'transfer_group': {
                if (this.filterSettingsForm.region == null || this.filterSettingsForm.date == null) {
                    return 'error_fill_region_date'
                }
                return 'error_no_transfer_group'
            }
            case 'direction': {
                const funding = this.filterSettingsForm.transferts.find(it => it.key === "funding")
                const transfer_group = this.filterSettingsForm.transferts.find(it => it.key === "transfer_group")

                if (this.filterSettingsForm.region == null || this.filterSettingsForm.date == null ||
                    (funding?.selected.length === 0) ||
                    (transfer_group?.selected.length === 0)
                ) {
                    return 'error_fill_transfert_base'
                }
                return 'error_no_transfert_direction'
            }
            case 'project': {
                const funding = this.filterSettingsForm.transferts.find(it => it.key === "funding")
                const transfer_group = this.filterSettingsForm.transferts.find(it => it.key === "transfer_group")
                const direction = this.filterSettingsForm.transferts.find(it => it.key === "direction")

                if (this.filterSettingsForm.region == null || this.filterSettingsForm.date == null ||
                    (funding?.selected.length === 0) ||
                    (transfer_group?.selected.length === 0) ||
                    (direction?.selected.length === 0)
                ) {
                    return 'error_fill_transfert_full'
                }
                return 'error_no_transfert_projects'
            }
            default: return 'error_no_data'
        }
    }
    public getExpensesSelectionWarningText(key: string): string {
        if (!this.filterSettingsForm || !('expenses' in this.filterSettingsForm)) {
            return ''
        }
        const hasOtherSelections = (this.filterSettingsForm as any).expenses
            ?.some((e: any) => e.key !== key && e.active && e.selected?.length > 0) ?? false

        switch (key) {
            case 'abp': {
                if ('region' in this.filterSettingsForm && this.filterSettingsForm.region == null) {
                    return 'placeholders.error_fill_region_only'
                }
                if (hasOtherSelections) {
                    return 'kbk.no_compatible_values'
                }
                return 'placeholders.error_no_abp_by_region'
            }
            default: {
                if (hasOtherSelections) {
                    return 'kbk.no_compatible_values'
                }
                return 'placeholders.error_no_data'
            }
        }
    }
    public getIncomesSelectionWarningText(key: string): string {
        if (!this.filterSettingsForm || !('incomes' in this.filterSettingsForm)) {
            return ''
        }
        const hasOtherSelections = (this.filterSettingsForm as any).incomes
            ?.some((e: any) => e.key !== key && e.active && e.selected?.length > 0) ?? false

        if (hasOtherSelections) {
            return 'kbk.no_compatible_values'
        }
        return 'placeholders.error_no_data'
    }

    public getGuSelectionWarningText(): string {
        if (!this.filterSettingsForm || !('expenses' in this.filterSettingsForm) || !('region' in this.filterSettingsForm) || !('gu' in this.filterSettingsForm)) {
            return ""
        }
        const abpFromForm = this.filterSettingsForm.expenses.find(e => e.key === 'abp')
        if (!abpFromForm) {
            return ""
        }


        if (this.filterSettingsForm.region == null ||
            !this.datePeriod
        ) {
            return 'error_fill_region_period'
        }
        return 'error_no_gu_complex'
    }

    get rsGuWarningText(): string {
        if (this.filterSettingsForm?.key !== 'RS') return ''
        const form = this.filterSettingsForm
        if (!form.region || !form.periodFrom || !form.periodTo) {
            return 'error_fill_region_period'
        }
        return 'error_no_gu_complex'
    }

    get rsGuListPlaceholder(): string {
        if (this.filterSettingsForm?.key !== 'RS') return ''
        const form = this.filterSettingsForm
        if (!form.region || !form.periodFrom || !form.periodTo) {
            return this.tr('placeholders.error_fill_region_period')
        }
        if (this.rsGuList.length === 0 && !this.rsGuLoading) {
            return this.tr('placeholders.error_no_gu_complex')
        }
        return this.tr('placeholders.all')
    }

    public selectAllRsGus() {
        if (this.filterSettingsForm?.key === 'RS') {
            if (this.filterSettingsForm.gus?.length === this.rsGuList.length && this.rsGuList.length > 0) {
                this.filterSettingsForm.gus = []
            } else {
                this.filterSettingsForm.gus = cloneDeep(this.rsGuList)
            }
        }
    }

    public async loadRsGuList() {
        if (this.filterSettingsForm?.key !== 'RS') return
        const form = this.filterSettingsForm
        if (!form.region || !form.periodFrom || !form.periodTo) {
            this.rsGuList = []
            return
        }
        const region = form.region.value
        const bdate = moment(form.periodFrom).format('YYYY-MM-DD')
        const edate = moment(form.periodTo).format('YYYY-MM-DD')
        const abpClassificator = form.expenses.find(e => e.key === 'abp')
        const abpsSelected = Array.isArray(abpClassificator?.selected) ? abpClassificator!.selected : []
        const abpsParam = abpsSelected.length > 0 ? abpsSelected.join(',') : ''

        this.rsGuLoading = true
        try {
            const url = `/api-py/monitoring/reports-constructor/rs-gu-list?user_id=${this.userId}&bdate=${bdate}&edate=${edate}&region=${region}&abps=${abpsParam}`
            const response = await fetch(url)
            if (!response.ok) {
                throw new Error('error_load_gu_failed')
            }
            const data = await response.json()
            this.rsGuList = data.map((it: any) => {
                const code = it.code ?? it.value ?? ''
                const obj: Option<string> = {
                    value: code,
                    label: code + ' - ' + (it.name_ru ?? it.label ?? ''),
                    labelKk: code + ' - ' + (it.name_kk ?? it.name_ru ?? ''),
                    labelEn: code + ' - ' + (it.name_en ?? it.name_ru ?? ''),
                }
                return obj
            })
        } catch (error) {
            this.rsGuList = []
            console.error('Ошибка при загрузке списка ГУ для RS:', error)
        } finally {
            this.rsGuLoading = false
        }
    }

    public async loadRsGuStatuses() {
        if (this.filterSettingsForm?.key !== 'RS') return
        const form = this.filterSettingsForm
        if (!form.region || !form.periodFrom || !form.periodTo) {
            this.rsGuStatusOptions = []
            return
        }
        const region = form.region.value
        const bdate = moment(form.periodFrom).format('YYYY-MM-DD')
        const edate = moment(form.periodTo).format('YYYY-MM-DD')
        try {
            const url = `/api-py/monitoring/reports-constructor/rs-gu-statuses?bdate=${bdate}&edate=${edate}&region=${region}`
            const response = await fetch(url)
            if (!response.ok) throw new Error('error_load_gu_statuses_failed')
            const data = await response.json()
            this.rsGuStatusOptions = data as Option<StatusType>[]
        } catch (error) {
            this.rsGuStatusOptions = []
            console.error('Ошибка при загрузке статусов ГУ для RS:', error)
        }
    }

    private getOptionLabel(option: Option<any>) : string {
        switch (this.tempI18Service.locale) {
            case 'kk':
                return option.labelKk || option.label || '';
            case 'en':
                return option.labelEn || option.label || '';
            case 'ru':
            default:
                return option.label || '';
        }
    }

    private disabledPeriodTo(dateToCheck: Date) {
        if (this.filterSettingsForm?.key === '2-43') {
            if ('periodTo' in this.filterSettingsForm) {
                const periodFrom: Date = this.filterSettingsForm.periodFrom
                const checkYear = dateToCheck.getFullYear()
                const refYear = periodFrom.getFullYear()
                return checkYear !== refYear
            }
        }
        return false
    }

    private disabledPeriodPrevFrom(dateToCheck:Date) {
        if (this.filterSettingsForm?.key === '2-43') {
            if ('periodTo' in this.filterSettingsForm) {
                const periodFrom: Date = this.filterSettingsForm.periodFrom
                const checkMonth = dateToCheck.getMonth()
                const checkYear = dateToCheck.getFullYear()
                const refMonth = periodFrom.getMonth()
                const refYear = periodFrom.getFullYear() - 1
                return checkMonth !== refMonth || checkYear !== refYear
            }
        }
        return false
    }

    private disabledPeriodPrevTo(dateToCheck:Date) {
        if (this.filterSettingsForm?.key === '2-43') {
            if ('periodTo' in this.filterSettingsForm) {
                const periodTo: Date = this.filterSettingsForm.periodTo
                const checkMonth = dateToCheck.getMonth()
                const checkYear = dateToCheck.getFullYear()
                const refMonth = periodTo.getMonth()
                const refYear = periodTo.getFullYear() - 1
                return checkMonth !== refMonth || checkYear !== refYear
            }
        }
        return false
    }

    private async get_243_filter_options(request: string) {
        const values: Option<string>[] = []
        const req: any = {
            'regions': [],
            'period_from': '2-2-2',
            'period_to': '2-2-2',
            'source': 'IISK',
            'senderbin': [],
            'oked': [],
            'kfs': [],
            'kse': [],
            'krp': [],
            'request': request
        }
        if (this.filterSettingsForm && this.filterSettingsForm.key === '2-43') {
            if ('regions' in this.filterSettingsForm) {
                if (this.filterSettingsForm.regions && this.filterSettingsForm.regions.length > 0) {
                    if (!this.filterSettingsForm.regions.length) {
                        return values
                    }
                    req.regions = this.filterSettingsForm.regions.map(it => it.value)
                }
            }
            if (!req.regions) {
                return values
            }
            if ('periodFrom' in this.filterSettingsForm) {
                const periodFrom: Date = this.filterSettingsForm.periodFrom
                req['period_from'] = `${periodFrom.getFullYear()}-${periodFrom.getMonth() + 1}-${periodFrom.getDate()}`
            }
            if ('periodTo' in this.filterSettingsForm) {
                const periodTo: Date = this.filterSettingsForm.periodTo
                req['period_to'] = `${periodTo.getFullYear()}-${periodTo.getMonth() + 1}-${periodTo.getDate()}`
            }
            if ('dataSource' in this.filterSettingsForm) {
                req['dataSource'] = this.filterSettingsForm.dataSource?.value
            }
            if ('senderbin' in this.filterSettingsForm && this.filterSettingsForm.senderbin.length > 0) {
                req['senderbin'] = this.filterSettingsForm.senderbin.map(it => it.value)
            }
            if ('oked' in this.filterSettingsForm && this.filterSettingsForm.oked.length > 0) {
                req['oked'] = this.filterSettingsForm.oked.map(it => it.value)
            }
            if ('kfs' in this.filterSettingsForm && this.filterSettingsForm.kfs.length > 0) {
                req['kfs'] = this.filterSettingsForm.kfs.map(it => it.value)
            }
            if ('kse' in this.filterSettingsForm && this.filterSettingsForm.kse.length > 0) {
                req['kse'] = this.filterSettingsForm.kse.map(it => it.value)
            }
            if ('krp' in this.filterSettingsForm && this.filterSettingsForm.krp.length > 0) {
                req['krp'] = this.filterSettingsForm.krp.map(it => it.value)
            }

        }
        await axios.post('/api-py/monitoring/reports-constructor/filter/2-43', req).then(resp => {
            if (resp.status === 200) {
                const options =  resp.data
                for (const opt of options) {
                    values.push({
                        value: opt.value,
                        label: opt.name_ru,
                        labelKk: opt.name_kk
                    })
                }
            }
        })
        return values
    }
    private async setSenderbinOptions() {
        if (this.filterSettingsForm) {
            const req: any = {}
            if ('regions' in this.filterSettingsForm) {
                if (this.filterSettingsForm.regions && this.filterSettingsForm.regions.length > 0) {
                    if (!this.filterSettingsForm.regions.length) {
                        return
                    }
                    req.region = this.filterSettingsForm.regions.map(it => it.value)
                }
            }
            if (!req.region) {
                return
            }
            if (!('senderbin' in this.filterSettingsForm) || !this.filterOptions || !('senderbin' in this.filterOptions)) {
                return
            }
            this.filterOptions.senderbin = await this.get_243_filter_options('bin')

        }
    }
    private async setOkedOptions() {
        if (this.filterSettingsForm && 'oked' in this.filterSettingsForm && this.filterOptions && 'oked' in this.filterOptions) {
            const values: Option<string>[] = await this.get_243_filter_options('oked')
            for (const opt of additionalSendersOptios) {
                values.push(opt)
            }
            this.filterOptions.oked = values
        }
    }
    private async setKfsOptions() {
        if (this.filterSettingsForm && 'kfs' in this.filterSettingsForm && this.filterOptions && 'kfs' in this.filterOptions) {
            const values: Option<string>[] = await this.get_243_filter_options('kfs')
            for (const opt of additionalSendersOptios) {
                values.push(opt)
            }
            this.filterOptions.kfs = values
        }
    }
    private async setKseOptions() {
        if (this.filterSettingsForm && 'kse' in this.filterSettingsForm && this.filterOptions && 'kse' in this.filterOptions) {
            const values: Option<string>[] = await this.get_243_filter_options('kse')
            for (const opt of additionalSendersOptios) {
                values.push(opt)
            }
            this.filterOptions.kse = values
        }
    }
    private async setKrpOptions() {
        if (this.filterSettingsForm && 'krp' in this.filterSettingsForm && this.filterOptions && 'krp' in this.filterOptions) {
            const values: Option<string>[] = await this.get_243_filter_options('krp')
            for (const opt of additionalSendersOptios) {
                values.push(opt)
            }
            this.filterOptions.krp = values
        }
    }

    // #endregion
}
